import React, { useState, useEffect } from 'react';
import AdminEntidades from './AdminEntidades';
import { 
  obtenerUsuarios, 
  crearUsuario, 
  generarClaveUsuario,
  actualizarUsuario, 
  eliminarUsuario,
  verificarCorreoExiste,
  obtenerEstadisticas,
  probarConexionAdmin,
  crearTransaccion,
  obtenerTransacciones,
  obtenerEstadisticasTransacciones,
  actualizarTransaccion,
  eliminarTransaccion,
  obtenerEstadisticasAnuncio,
  guardarConfiguracionAnuncio,
  obtenerConfiguracionAnuncio,
  obtenerUsuariosConectadosPorFecha,
  obtenerConfiguracionAccesos,
  guardarAccesosGenerador,
  guardarGruposCurso
} from '../services/adminService';
import { PLANES_ASIGNABLES, PERFILES_GRUPO_CURSO } from './planPermissions';
import { useDashboard } from '../contexts/DashboardContext';
import { usePac } from '../contexts/PacContext';

// Dirección que se envía al cliente junto con sus credenciales. Es siempre el
// dominio del portal, no por dónde haya entrado el administrador: abriendo el
// panel desde la URL de Vercel, `window.location.origin` colaba esa dirección
// en el mensaje de WhatsApp del cliente. Se cambia con REACT_APP_URL_PORTAL
// (en Vercel y en `.env.production`) el día que se mude el dominio.
const URL_PORTAL = (process.env.REACT_APP_URL_PORTAL || 'https://app.licitahub.pe')
  .replace(/\/+$/, '');

// Primera línea del mensaje, según de dónde salga la contraseña.
const ENCABEZADO_USUARIO_NUEVO = '✅ Usuario registrado correctamente';
const ENCABEZADO_CLAVE_NUEVA = '🔑 Contraseña nueva de tu cuenta';

const textoCredenciales = (correo, clave, encabezado = ENCABEZADO_CLAVE_NUEVA) =>
  `${encabezado}

🌐 Link de app de licitaciones: ${URL_PORTAL}/

📧 Puedes ingresar con tu Gmail o con las siguientes "Credenciales":
- Correo: ${correo}
- Contraseña: ${clave}`;

/** Copia al portapapeles; devuelve false si el navegador no lo permite. */
const copiarCredenciales = async (correo, clave, encabezado) => {
  const texto = textoCredenciales(correo, clave, encabezado);
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(texto);
      return true;
    }
  } catch { /* sin permiso: se intenta la vía antigua */ }
  try {
    const area = document.createElement('textarea');
    area.value = texto;
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
};

const Admin = () => {

  
  // Estado para el formulario de registro
  const [form, setForm] = useState({
    celular: '',
    correo: '',
    nombre: '',
    empresa: '',
    plan: '',
    ruc: '',
    valor: '',
    fecha_inicio: '',
    mes_suscripcion: 0,
    dias_adicionales: 0,
    fecha_fin: '',
    comentarios: '',
      medio_pago: '',
  comprobante: '',
  flag_depositado: false,
  flag_emitido: false,
  curso_tipo: '', 
  });

  // Estado para el formulario de registro de pago
  const [formPago, setFormPago] = useState({
    celular: '',
    correo: '',
    plan: '',
    valor: '',
    medio_pago: '',
    comprobante: '',
    cant_meses: '',
    flag_depositado: false,
    flag_emitido: false,
    curso_tipo: '',
  });

  // Estados para la gestión de usuarios
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('usuarios');
  // Accesos configurables: planes con acceso al Generador de Oferta
  const [generadorPlanes, setGeneradorPlanes] = useState([]);
  const [guardandoAccesos, setGuardandoAccesos] = useState(false);
  const [cursoExpandido, setCursoExpandido] = useState(false);
  const [filtro, setFiltro] = useState('todos');
  const [busqueda, setBusqueda] = useState('');
  const [filtroPlan, setFiltroPlan] = useState('todos');
  const [filtroGrupo, setFiltroGrupo] = useState('todos');
  const [conexionOk, setConexionOk] = useState(false);
  const [estadisticas, setEstadisticas] = useState({
    total: 0,
    vigentes: 0,
    por_vencer: 0,
    vencidos: 0,
    ingresos_totales: 0
  });
  const [filtroTipoIngreso, setFiltroTipoIngreso] = useState('todos');
  const [sortVencidos, setSortVencidos] = useState('recientes'); // 'recientes' | 'antiguos'
  // Estados para transacciones
  const [transacciones, setTransacciones] = useState([]);
  const [estadisticasTransacciones, setEstadisticasTransacciones] = useState({
    total_transacciones: 0,
    ingresos_totales: 0,
    por_plan: {},
    meses_vendidos: 0
  });
  const [busquedaTransacciones, setBusquedaTransacciones] = useState('');
  const [loadingPago, setLoadingPago] = useState(false);
  
  // Estados para edición inline
  const [editingUser, setEditingUser] = useState(null);
  const [editData, setEditData] = useState({});
  // Estados para edición masiva (panel de varios usuarios a la vez)
  const [bulkEditOpen, setBulkEditOpen] = useState(false);
  const [bulkSelected, setBulkSelected] = useState({}); // { [correo]: true }
  const [bulkAdd, setBulkAdd] = useState({}); // { [correo]: { meses, dias } }
  const [bulkMeses, setBulkMeses] = useState('');
  const [bulkDias, setBulkDias] = useState('');
  const [bulkBusqueda, setBulkBusqueda] = useState('');
  const [bulkFiltroPlan, setBulkFiltroPlan] = useState('todos');
  const [bulkFiltroGrupo, setBulkFiltroGrupo] = useState('todos');
  const [bulkFiltroEstado, setBulkFiltroEstado] = useState('todos');
  const [savingBulk, setSavingBulk] = useState(false);
// Agregar este estado junto con los otros estados
const [usuarioEncontrado, setUsuarioEncontrado] = useState(null);
  // Estados para control del dashboard
  const [refreshingDashboard, setRefreshingDashboard] = useState(false);
  // Contraseñas recién generadas: se muestran una sola vez, la base solo guarda el hash
  const [claveGenerada, setClaveGenerada] = useState(null);

  // Estados para el gráfico de ingresos diarios
  const [ingresosDiarios, setIngresosDiarios] = useState([]);
const [filtroMes, setFiltroMes] = useState(''); // AGREGAR
const [filtroFechaInicio, setFiltroFechaInicio] = useState(''); // AGREGAR
const [filtroFechaFin, setFiltroFechaFin] = useState(''); // AGREGAR
const [ingresosFiltrados, setIngresosFiltrados] = useState([]); // AGREGAR
const [vistaGrafico, setVistaGrafico] = useState('diario'); // 'diario' | 'mensual'
// Grupos del plan Curso. Viven en Supabase (configuracion_accesos.grupos_curso)
// porque el portal del alumno también los lee: de su perfil depende qué secciones
// ve. Lo que quedaba en localStorage se sube la primera vez y luego se ignora.
const GRUPOS_CURSO_POR_DEFECTO = [
  { id: 1, nombre: 'MENORES', descripcion: 'Contratos Menores', precio: 80, perfil: 'MENOR' },
  { id: 2, nombre: 'MAYORES', descripcion: 'Contratos Mayores', precio: 100, perfil: 'PREMIUM' },
  { id: 3, nombre: 'AMBOS', descripcion: 'Ambos Cursos', precio: 150, perfil: 'PREMIUM' },
];
const [gruposCurso, setGruposCurso] = useState([]);
const [guardandoGrupos, setGuardandoGrupos] = useState(false);
const [formGrupo, setFormGrupo] = useState({ nombre: '', descripcion: '', precio: '', perfil: 'MENOR' });
// Estados para edición de transacciones (AGREGAR DESPUÉS DE LOS ESTADOS EXISTENTES)
const [editingTransaction, setEditingTransaction] = useState(null);
const [editTransactionData, setEditTransactionData] = useState({});
  // Usar contextos del dashboard
  const {
    handleRefresh: refreshContractosMenores,
    refreshing: refreshingMenores,
    lastUpdate: lastUpdateMenores,
    stats: statsMenores,
    initialized: initializedMenores
  } = useDashboard();

  const {
    handleRefreshPac,
    pacVigenteLoading,
    pacProgramadoLoading,
    pacVigenteLastUpdate,
    pacProgramadoLastUpdate,
    pacVigenteStats,
    pacProgramadoStats
  } = usePac();
// Calcular precio según tipo de curso (dinámico desde grupos)
const calcularPrecioCurso = (tipoCurso) => {
  if (!tipoCurso) return 0;
  const grupo = gruposCurso.find(g => g.nombre === tipoCurso);
  return grupo ? grupo.precio : 0;
};
// FUNCIÓN CRÍTICA - CALCULAR FECHA FIN - VERSIÓN CORREGIDA
const calcularFechaFin = (fechaInicio, meses, diasAdicionales) => {
  if (!fechaInicio) return '';
  
  // Convertir valores a números, pero respetando el 0
  const mesesNum = meses === '' ? 0 : parseInt(meses) || 0;
  const diasNum = diasAdicionales === '' ? 0 : parseInt(diasAdicionales) || 0;
  
  // Si no hay meses ni días, retornar fecha de inicio con hora final
  if (mesesNum === 0 && diasNum === 0) {
    return fechaInicio + 'T23:59:59.999Z';
  }
  
  // Parsear la fecha de inicio
  const [year, month, day] = fechaInicio.split('-').map(Number);
  
  // Crear fecha base en UTC
  let fechaFin = new Date(Date.UTC(year, month - 1, day));
  
  // CASO ESPECIAL: Si solo hay días (meses = 0), agregar días directamente
  if (mesesNum === 0 && diasNum > 0) {
    fechaFin.setUTCDate(fechaFin.getUTCDate() + diasNum);
  } else {
    // PASO 1: Si hay meses, agregarlos primero
    if (mesesNum > 0) {
      let mesActual = fechaFin.getUTCMonth();
      let añoActual = fechaFin.getUTCFullYear();
      const diaOriginal = fechaFin.getUTCDate();
      
      // Calcular el nuevo mes y año
      mesActual += mesesNum;
      while (mesActual >= 12) {
        mesActual -= 12;
        añoActual += 1;
      }
      
      // Obtener el último día del mes de destino
      const ultimoDiaDelMes = new Date(Date.UTC(añoActual, mesActual + 1, 0)).getUTCDate();
      
      // Usar el día original o el último día del mes si es menor
      const diaFinal = Math.min(diaOriginal, ultimoDiaDelMes);
      
      // Establecer la nueva fecha con los meses agregados
      fechaFin = new Date(Date.UTC(añoActual, mesActual, diaFinal));
    }
    
    // PASO 2: Si hay días adicionales, agregarlos después de los meses
    if (diasNum > 0) {
      fechaFin.setUTCDate(fechaFin.getUTCDate() + diasNum);
    }
  }
  
  // Formatear resultado con hora final del día
  const finalYear = fechaFin.getUTCFullYear();
  const finalMonth = String(fechaFin.getUTCMonth() + 1).padStart(2, '0');
  const finalDay = String(fechaFin.getUTCDate()).padStart(2, '0');
  
  return `${finalYear}-${finalMonth}-${finalDay}T23:59:59.999Z`;
};
const [formPreferencias, setFormPreferencias] = useState({
  correo: '',
  flag_correo: '',
  palabras_claves: '',
  departamentos: '',
  tipo: '',
  flag_sunat: '',
  correos_cc: ''
});
const [loadingPreferencias, setLoadingPreferencias] = useState(false);
const [usuarioBuscado, setUsuarioBuscado] = useState(null);
// ✅ ESTADOS PARA ANUNCIOS
const [grupoWhatsAppId, setGrupoWhatsAppId] = useState('D2Dq4IKd4IhDca8zuAIH3a');
const [loadingAnuncio, setLoadingAnuncio] = useState(false);
const [estadisticasAnuncio, setEstadisticasAnuncio] = useState(null);
// ✅ ESTADOS PARA ACTIVIDAD
const [usuariosConectadosHoy, setUsuariosConectadosHoy] = useState([]);
const [loadingActividad, setLoadingActividad] = useState(false);
const [fechaActividad, setFechaActividad] = useState(() => new Date().toISOString().split('T')[0]);
// Estados para creación en grupo
const [showModalGrupo, setShowModalGrupo] = useState(false);
const [configGrupo, setConfigGrupo] = useState({
  plan: '', curso_tipo: '', fecha_inicio: '', mes_suscripcion: 1,
  dias_adicionales: 0, valor: '', medio_pago: '', comprobante: '',
  flag_emitido: false, flag_depositado: false,
});
const [usuariosGrupo, setUsuariosGrupo] = useState([
  { id: 1, nombre: '', correo: '', celular: '', empresa: '', ruc: '', comentarios: '', comprobante: '', valor: '', dias_extra: '', flag_emitido: false, flag_depositado: false }
]);
const [resultadosGrupo, setResultadosGrupo] = useState([]);
const [loadingGrupo, setLoadingGrupo] = useState(false);
const [mostrarResultadosGrupo, setMostrarResultadosGrupo] = useState(false);
const [plantillaMensaje, setPlantillaMensaje] = useState(
`Hola, te envío tus accesos al app de licitaciones\n\n🌐 Link de app de licitaciones: ${URL_PORTAL}/\n🌐 Link clases grabadas: https://aulavirtualnuvia.lovable.app/\n\n📧 Puedes ingresar con tu Gmail o con las siguientes "Credenciales":\n- Correo: {correo}\n- Contraseña: {clave}`
);
// Función de prueba para verificar que funciona correctamente
const probarCalculos = () => {
  console.log('=== PRUEBAS DE CÁLCULO DE FECHA FIN ===');
  
  // Caso 1: Solo días (EL PROBLEMA ORIGINAL)
  console.log('1. Solo días (2 días):');
  console.log('   Entrada: 2025-09-20, 0 meses, 2 días');
  console.log('   Resultado:', calcularFechaFin('2025-09-20', 0, 2));
  console.log('   Esperado: 2025-09-22 (20 sep + 2 días = 22 sep)');
  
  // Caso 2: Solo meses
  console.log('\n2. Solo meses (2 meses):');
  console.log('   Entrada: 2025-01-15, 2 meses, 0 días');
  console.log('   Resultado:', calcularFechaFin('2025-01-15', 2, 0));
  console.log('   Esperado: 2025-03-15');
  
  // Caso 3: Meses + días
  console.log('\n3. Meses + días (1 mes + 15 días):');
  console.log('   Entrada: 2025-01-15, 1 mes, 15 días');
  console.log('   Resultado:', calcularFechaFin('2025-01-15', 1, 15));
  console.log('   Esperado: 2025-03-01 (15 ene + 1 mes = 15 feb + 15 días = 1 mar)');
  
  console.log('\n=== FIN DE PRUEBAS ===');
};

// Ejecutar pruebas
probarCalculos();

  // Función para calcular días restantes - CORREGIDA
  const calcularDiasRestantes = (fechaFin) => {
    if (!fechaFin) return 0;
    
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0); // Inicio del día actual
    
    const fin = new Date(fechaFin);
    // La fecha fin ya incluye T23:59:59.999Z, así que no necesitamos modificarla
    
    const diffTime = fin.getTime() - hoy.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays;
  };

  // Función para verificar acceso activo - CORREGIDA
  const tieneAccesoActivo = (fechaFin) => {
    if (!fechaFin) return false;
    
    const ahora = new Date();
    const fin = new Date(fechaFin);
    // La fecha fin ya incluye T23:59:59.999Z
    
    return fin.getTime() >= ahora.getTime();
  };

  // Función para procesar ingresos diarios
// Función para procesar ingresos diarios
const procesarIngresosDiarios = (transacciones) => {
  const ingresosPorDia = {};
  const ingresosPorDiaApp = {};
  const ingresosPorDiaCursos = {};
  
  transacciones.forEach(transaccion => {
    // ✅ Crear objeto Date y extraer año, mes, día en UTC
    const fechaObj = new Date(transaccion.created_at);
    const year = fechaObj.getFullYear();
    const month = String(fechaObj.getMonth() + 1).padStart(2, '0');
    const day = String(fechaObj.getDate()).padStart(2, '0');
    
    // ✅ Formato consistente: DD/MM/YYYY
    const fechaDisplay = `${day}/${month}/${year}`;
    
    const monto = parseFloat(transaccion.valor) || 0;
    const esCurso = transaccion.plan === 'CURSO';
    
    // Total general
    if (!ingresosPorDia[fechaDisplay]) {
      ingresosPorDia[fechaDisplay] = 0;
    }
    ingresosPorDia[fechaDisplay] += monto;
    
    // Ingresos App (todos menos CURSO)
    if (!esCurso) {
      if (!ingresosPorDiaApp[fechaDisplay]) {
        ingresosPorDiaApp[fechaDisplay] = 0;
      }
      ingresosPorDiaApp[fechaDisplay] += monto;
    }
    
    // Ingresos Cursos
    if (esCurso) {
      if (!ingresosPorDiaCursos[fechaDisplay]) {
        ingresosPorDiaCursos[fechaDisplay] = 0;
      }
      ingresosPorDiaCursos[fechaDisplay] += monto;
    }
  });
  
  // ✅ Convertir a arrays con fechas correctas
  const convertirAArray = (obj) => {
    return Object.entries(obj)
      .map(([fecha, monto]) => {
        // ✅ Parsear DD/MM/YYYY correctamente
        const [day, month, year] = fecha.split('/');
        const fechaOrden = new Date(year, month - 1, day);
        
        return {
          fecha,
          monto,
          fechaOrden
        };
      })
      .sort((a, b) => a.fechaOrden - b.fechaOrden);
  };
  
  const resultado = {
    todos: convertirAArray(ingresosPorDia),
    app: convertirAArray(ingresosPorDiaApp),
    cursos: convertirAArray(ingresosPorDiaCursos)
  };
  
  console.log('=== PROCESAMIENTO DE INGRESOS ===');
  console.log('Total de fechas procesadas:', resultado.todos.length);
  if (resultado.todos.length > 0) {
    console.log('Primera fecha:', resultado.todos[0]);
    console.log('Última fecha:', resultado.todos[resultado.todos.length - 1]);
  }
  console.log('=================================');
  
  return resultado;
};
// Función para filtrar ingresos por fecha
// Función para filtrar ingresos por fecha
const filtrarIngresosPorFecha = (ingresos) => {
  let ingresosFiltrados = [...ingresos];
  
  // Filtrar por mes específico
  if (filtroMes) {
    ingresosFiltrados = ingresosFiltrados.filter(item => {
      const fecha = new Date(item.fechaOrden);
      const mesAno = `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}`;
      return mesAno === filtroMes;
    });
  }
  
  // Filtrar por rango de fechas
  if (filtroFechaInicio) {
    const fechaInicio = new Date(filtroFechaInicio);
    ingresosFiltrados = ingresosFiltrados.filter(item => 
      item.fechaOrden >= fechaInicio
    );
  }
  
  if (filtroFechaFin) {
    const fechaFin = new Date(filtroFechaFin);
    fechaFin.setHours(23, 59, 59, 999); // Incluir todo el día final
    ingresosFiltrados = ingresosFiltrados.filter(item => 
      item.fechaOrden <= fechaFin
    );
  }
  
  return ingresosFiltrados;
};
// Función para eliminar transacción - AGREGAR ESTA FUNCIÓN
const eliminarTransaccionHandler = async (transaccionId, correoUsuario, planUsuario) => {
  const confirmacion = window.confirm(
    `¿Estás seguro de que quieres eliminar esta transacción?\n\n` +
    `Usuario: ${correoUsuario}\n` +
    `Plan: ${planUsuario}\n\n` +
    `Esta acción no se puede deshacer.`
  );
  
  if (!confirmacion) return;

  try {
    await eliminarTransaccion(transaccionId);
    alert('✅ Transacción eliminada correctamente');
    await cargarTransacciones();
    await cargarEstadisticasTransacciones();
  } catch (error) {
    console.error('Error:', error);
    alert(`❌ Error al eliminar transacción: ${error.message}`);
  }
};
// Función para obtener opciones de meses disponibles
const obtenerOpcionesMeses = () => {
  const meses = new Set();
  
  transacciones.forEach(transaccion => {
    const fecha = new Date(transaccion.created_at);
    const mesAno = `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}`;
    meses.add(mesAno);
  });
  
  return Array.from(meses).sort().map(mesAno => {
    const [ano, mes] = mesAno.split('-');
    const nombreMes = new Date(ano, mes - 1).toLocaleDateString('es-PE', { 
      month: 'long', 
      year: 'numeric' 
    });
    return { value: mesAno, label: nombreMes };
  });
};


const userData = JSON.parse(sessionStorage.getItem('nuvia_user') || localStorage.getItem('nuvia_user') || '{}');
const isAuthorized = userData.email === 'consultingnuvia@gmail.com';

  // Cargar datos al montar el componente
useEffect(() => {
    if (isAuthorized) {
      verificarConexion();
      cargarUsuarios();
      cargarEstadisticas();
      cargarTransacciones();
      cargarEstadisticasTransacciones();
    }
  }, [isAuthorized]);
// ✅ CARGAR CONFIGURACIÓN DEL GRUPO
useEffect(() => {
  if (isAuthorized) {
    cargarConfiguracionGrupo();
  }
}, [isAuthorized]);

const cargarConfiguracionGrupo = async () => {
  try {
    const config = await obtenerConfiguracionAnuncio();
    setGrupoWhatsAppId(config.grupo_whatsapp_id);
  } catch (error) {
    console.error('Error cargando configuración:', error);
  }
};

// ✅ CARGAR ACCESOS DEL GENERADOR DE OFERTA
useEffect(() => {
  if (isAuthorized) {
    cargarAccesosGenerador();
  }
}, [isAuthorized]);

const cargarAccesosGenerador = async () => {
  try {
    const config = await obtenerConfiguracionAccesos();
    const planes = (config.generadorPlanes || []).map(p => String(p).trim().toUpperCase());
    setGeneradorPlanes(planes);
    // Expandir la sección de Curso si hay algún acceso de curso configurado
    setCursoExpandido(planes.includes('CURSO') || planes.some(p => p.startsWith('CURSO:')));

    // Los grupos que aún estén solo en este navegador se suben una única vez;
    // a partir de ahí manda Supabase, que es lo que lee el portal del alumno.
    let grupos = config.grupos || [];
    if (grupos.length === 0) {
      let heredados = [];
      try {
        const guardado = localStorage.getItem('nuvia_grupos_curso');
        heredados = guardado ? JSON.parse(guardado) : [];
      } catch { heredados = []; }
      grupos = (Array.isArray(heredados) && heredados.length > 0)
        ? heredados
        : GRUPOS_CURSO_POR_DEFECTO;
      try {
        await guardarGruposCurso(grupos);
        localStorage.removeItem('nuvia_grupos_curso');
      } catch (error) {
        console.error('No se pudieron subir los grupos de curso:', error);
      }
    }
    setGruposCurso(grupos);
  } catch (error) {
    console.error('Error cargando accesos del generador:', error);
  }
};

const togglePlanGenerador = (codigo) => {
  setGeneradorPlanes(prev =>
    prev.includes(codigo) ? prev.filter(p => p !== codigo) : [...prev, codigo]
  );
};

// Plan CURSO: la casilla maestra despliega los grupos creados. Al desmarcarla
// se limpian todos los accesos de curso.
const toggleCursoExpandido = () => {
  setCursoExpandido(prev => {
    const next = !prev;
    if (!next) {
      setGeneradorPlanes(gp => gp.filter(p => p !== 'CURSO' && !p.startsWith('CURSO:')));
    }
    return next;
  });
};

// "Todos los grupos": guarda el código simple 'CURSO' (y quita selecciones por grupo)
const toggleCursoTodos = () => {
  setGeneradorPlanes(prev => {
    if (prev.includes('CURSO')) return prev.filter(p => p !== 'CURSO');
    return [...prev.filter(p => !p.startsWith('CURSO:')), 'CURSO'];
  });
};

// Un grupo específico: guarda 'CURSO:<NOMBRE>' (y quita el "todos")
const toggleCursoGrupo = (nombreGrupo) => {
  const code = `CURSO:${String(nombreGrupo).trim().toUpperCase()}`;
  setGeneradorPlanes(prev => {
    const base = prev.filter(p => p !== 'CURSO');
    return base.includes(code) ? base.filter(p => p !== code) : [...base, code];
  });
};

const guardarAccesosGeneradorHandler = async () => {
  setGuardandoAccesos(true);
  try {
    await guardarAccesosGenerador(generadorPlanes);
    alert('✅ Accesos del Generador de Oferta guardados correctamente');
  } catch (error) {
    console.error('Error al guardar accesos:', error);
    const detalle = error?.message || error?.details || error?.hint || error?.code || 'Error desconocido';
    const codigo = error?.code ? ` (código ${error.code})` : '';
    alert('❌ Error al guardar los accesos: ' + detalle + codigo);
  } finally {
    setGuardandoAccesos(false);
  }
};

// Funciones para gestión de grupos de cursos
const persistirGruposCurso = async (grupos) => {
  const previos = gruposCurso;
  setGruposCurso(grupos); // respuesta inmediata; si falla el guardado se revierte
  setGuardandoGrupos(true);
  try {
    await guardarGruposCurso(grupos);
    return true;
  } catch (error) {
    console.error('Error guardando los grupos de curso:', error);
    setGruposCurso(previos);
    const detalle = error?.message || error?.details || error?.hint || 'Error desconocido';
    alert('❌ No se pudieron guardar los grupos: ' + detalle);
    return false;
  } finally {
    setGuardandoGrupos(false);
  }
};

const agregarGrupoCurso = async () => {
  if (!formGrupo.nombre.trim()) {
    alert('❌ El nombre del grupo es requerido');
    return;
  }
  const existe = gruposCurso.some(g => g.nombre.toUpperCase() === formGrupo.nombre.toUpperCase().trim());
  if (existe) {
    alert('❌ Ya existe un grupo con ese nombre');
    return;
  }
  const nuevoGrupo = {
    id: Date.now(),
    nombre: formGrupo.nombre.toUpperCase().trim().replace(/\s+/g, '_'),
    descripcion: formGrupo.descripcion.trim(),
    precio: parseFloat(formGrupo.precio) || 0,
    perfil: formGrupo.perfil || 'MENOR',
  };
  const ok = await persistirGruposCurso([...gruposCurso, nuevoGrupo]);
  if (!ok) return;
  setFormGrupo({ nombre: '', descripcion: '', precio: '', perfil: 'MENOR' });
  alert('✅ Grupo creado correctamente');
};

// El perfil se puede cambiar sobre la marcha: los grupos que ya existían no
// traen ninguno y hay que poder asignárselo sin borrarlos y volverlos a crear.
const cambiarPerfilGrupo = (id, perfil) => {
  persistirGruposCurso(gruposCurso.map(g => (g.id === id ? { ...g, perfil } : g)));
};

const eliminarGrupoCurso = (id) => {
  const grupo = gruposCurso.find(g => g.id === id);
  if (!window.confirm(`¿Eliminar el grupo "${grupo?.nombre}"?`)) return;
  persistirGruposCurso(gruposCurso.filter(g => g.id !== id));
};
  // Verificar conexión a Supabase
  const verificarConexion = async () => {
    const ok = await probarConexionAdmin();
    setConexionOk(ok);
  };

  // Cargar usuarios desde Supabase
  const cargarUsuarios = async () => {
    setLoading(true);
    try {
      const data = await obtenerUsuarios();
      const usuariosConDias = data.map(usuario => ({
        ...usuario,
        dias_restantes: calcularDiasRestantes(usuario.fecha_fin),
        acceso_activo: tieneAccesoActivo(usuario.fecha_fin)
      }));
      setUsuarios(usuariosConDias);
    } catch (error) {
      console.error('Error cargando usuarios:', error);
      alert('❌ Error al cargar usuarios: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Cargar estadísticas
  const cargarEstadisticas = async () => {
    try {
      const stats = await obtenerEstadisticas();
      setEstadisticas(stats);
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
    }
  };

  // Cargar transacciones
 // Cargar transacciones
const cargarTransacciones = async () => {
  try {
    const data = await obtenerTransacciones();
    setTransacciones(data);
    // Procesar ingresos diarios cuando se cargan las transacciones
    const ingresosDiariosData = procesarIngresosDiarios(data);
    setIngresosDiarios(ingresosDiariosData);
    // Inicializar ingresos filtrados

    setIngresosFiltrados(ingresosDiariosData); // AGREGAR ESTA LÍNEA
  window.ingresosDiariosDetallados = ingresosDiariosData; 
  } catch (error) {
    console.error('Error cargando transacciones:', error);
  }
};
// Función para renderizar controles de filtro
const renderFiltrosGrafico = () => {
  const opcionesMeses = obtenerOpcionesMeses();
    return (
    <div className="row mb-3">
      {/* ✅ NUEVO: Filtro por tipo de ingreso */}
      <div className="col-md-3">
        <label className="form-label fw-bold">💰 Tipo de Ingreso:</label>
        <select
          className="form-select"
          value={filtroTipoIngreso}
          onChange={(e) => setFiltroTipoIngreso(e.target.value)}
        >
          <option value="todos">📊 Todos los ingresos</option>
          <option value="app">📱 Solo App Licitaciones</option>
          <option value="cursos">🎓 Solo Cursos</option>
        </select>
      </div>
      
      <div className="col-md-3">
        <label className="form-label fw-bold">📅 Filtrar por mes:</label>
        <select
          className="form-select"
          value={filtroMes}
          onChange={(e) => setFiltroMes(e.target.value)}
        >
          <option value="">Todos los meses</option>
          {opcionesMeses.map(opcion => (
            <option key={opcion.value} value={opcion.value}>
              {opcion.label}
            </option>
          ))}
        </select>
      </div>
      
      <div className="col-md-2">
        <label className="form-label fw-bold">📅 Desde:</label>
        <input
          type="date"
          className="form-control"
          value={filtroFechaInicio}
          onChange={(e) => setFiltroFechaInicio(e.target.value)}
        />
      </div>
      
      <div className="col-md-2">
        <label className="form-label fw-bold">📅 Hasta:</label>
        <input
          type="date"
          className="form-control"
          value={filtroFechaFin}
          onChange={(e) => setFiltroFechaFin(e.target.value)}
        />
      </div>
      
      <div className="col-md-2 d-flex align-items-end">
        <button
          className="btn btn-outline-secondary w-100"
          onClick={() => {
            setFiltroMes('');
            setFiltroFechaInicio('');
            setFiltroFechaFin('');
            setFiltroTipoIngreso('todos');
          }}
        >
          🗑️ Limpiar
        </button>
      </div>
    </div>
  );
};

  // Cargar estadísticas de transacciones
  const cargarEstadisticasTransacciones = async () => {
    try {
      const stats = await obtenerEstadisticasTransacciones();
      setEstadisticasTransacciones(stats);
    } catch (error) {
      console.error('Error cargando estadísticas de transacciones:', error);
    }
  };

  const cargarUsuariosConectadosHoy = async (fecha) => {
    setLoadingActividad(true);
    try {
      const fechaConsulta = fecha || fechaActividad;
      const data = await obtenerUsuariosConectadosPorFecha(fechaConsulta);
      setUsuariosConectadosHoy(data);
    } catch (error) {
      console.error('Error cargando actividad:', error);
    } finally {
      setLoadingActividad(false);
    }
  };

  // Actualizar todo el dashboard
  const actualizarDashboard = async () => {
    setRefreshingDashboard(true);
    try {
      console.log('🔄 Admin: Iniciando actualización completa del dashboard...');
      
      await refreshContractosMenores();
      await handleRefreshPac();
      
      alert('✅ Dashboard actualizado exitosamente desde panel de administración');
      console.log('✅ Admin: Dashboard actualizado completamente');
      
    } catch (error) {
      console.error('❌ Admin: Error al actualizar dashboard:', error);
      alert('❌ Error al actualizar el dashboard. Intente nuevamente.');
    } finally {
      setRefreshingDashboard(false);
    }
  };

  // Obtener el estado de actualización del dashboard
  const getEstadoDashboard = () => {
    const isAnyLoading = refreshingMenores || pacVigenteLoading || pacProgramadoLoading || refreshingDashboard;
    
    if (isAnyLoading) {
      return {
        estado: 'Actualizando...',
        color: 'warning',
        icon: '🔄'
      };
    }
    
    if (!initializedMenores) {
      return {
        estado: 'No inicializado',
        color: 'secondary',
        icon: '⭕'
      };
    }
    
    return {
      estado: 'Actualizado',
      color: 'success',
      icon: '✅'
    };
  };

  // Formatear fecha de última actualización
  const formatearUltimaActualizacion = (fecha) => {
    if (!fecha) return 'Nunca';
    
    const now = new Date();
    const diff = now.getTime() - fecha.getTime();
    const minutes = Math.floor(diff / (1000 * 60));
    
    if (minutes < 1) return 'Hace menos de un minuto';
    if (minutes === 1) return 'Hace 1 minuto';
    if (minutes < 60) return `Hace ${minutes} minutos`;
    
    const hours = Math.floor(minutes / 60);
    if (hours === 1) return 'Hace 1 hora';
    if (hours < 24) return `Hace ${hours} horas`;
    
    return fecha.toLocaleDateString('es-PE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Establecer fecha actual
  const setFechaHoy = () => {
    const hoy = new Date().toISOString().split('T')[0];
    setForm((prev) => ({ ...prev, fecha_inicio: hoy }));
  };

  // Variables para el useEffect
  const { fecha_inicio, mes_suscripcion, dias_adicionales } = form;

useEffect(() => {
  if (fecha_inicio  && isAuthorized) {
    // CONVERSIÓN CORRECTA: Aquí sí convertimos a número
    const mesesNum = mes_suscripcion === '' || mes_suscripcion === null || mes_suscripcion === undefined ? 0 : parseInt(mes_suscripcion);
    const diasNum = dias_adicionales === '' || dias_adicionales === null || dias_adicionales === undefined ? 0 : parseInt(dias_adicionales);
    
    console.log('=== useEffect CÁLCULO FECHA ===');
    console.log('fecha_inicio:', fecha_inicio);
    console.log('mes_suscripcion (raw):', mes_suscripcion, typeof mes_suscripcion);
    console.log('dias_adicionales (raw):', dias_adicionales, typeof dias_adicionales);
    console.log('mesesNum convertido:', mesesNum);
    console.log('diasNum convertido:', diasNum);
    
    const fechaFinCalculada = calcularFechaFin(fecha_inicio, mesesNum, diasNum);
    console.log('Fecha fin calculada:', fechaFinCalculada);
    console.log('==============================');
    
    setForm((prev) => ({ ...prev, fecha_fin: fechaFinCalculada }));
  }
}, [fecha_inicio, mes_suscripcion, dias_adicionales,isAuthorized]);

useEffect(() => {
  if (editData.fecha_inicio && editingUser  && isAuthorized) {
    const fechaFinCalculada = calcularFechaFin(
      editData.fecha_inicio, 
      editData.mes_suscripcion || 0, 
      editData.dias_adicionales || 0
    );
    
    // Solo actualizar si realmente cambió (evitar loops infinitos)
    if (fechaFinCalculada !== editData.fecha_fin) {
      setEditData((prev) => ({ 
        ...prev, 
        fecha_fin: fechaFinCalculada 
      }));
    }
  }
}, [editData.fecha_inicio, editData.mes_suscripcion, editData.dias_adicionales, editingUser,isAuthorized]);
// useEffect para filtrar ingresos cuando cambian los filtros
// useEffect para filtrar ingresos cuando cambian los filtros
useEffect(() => {
  if (isAuthorized) {
    // ✅ MODIFICADO: Aplicar filtro de tipo de ingreso con validación
    let datosBase = [];
    
    if (window.ingresosDiariosDetallados) {
      switch(filtroTipoIngreso) {
        case 'app':
          datosBase = window.ingresosDiariosDetallados.app || [];
          break;
        case 'cursos':
          datosBase = window.ingresosDiariosDetallados.cursos || [];
          break;
        default:
          datosBase = window.ingresosDiariosDetallados.todos || [];
      }
    } else if (Array.isArray(ingresosDiarios)) {
      datosBase = ingresosDiarios;
    } else if (ingresosDiarios?.todos) {
      datosBase = ingresosDiarios.todos || [];
    }
    
    // Asegurar que sea un array
    if (!Array.isArray(datosBase)) {
      datosBase = [];
    }
    
    const datosFiltrados = filtrarIngresosPorFecha(datosBase);
    setIngresosFiltrados(datosFiltrados);
  }
}, [ingresosDiarios, filtroMes, filtroFechaInicio, filtroFechaFin, filtroTipoIngreso, isAuthorized]);// Return condicional para acceso denegado
  if (!isAuthorized) {
    return (
      <div className="container-fluid py-4" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', minHeight: '100vh' }}>
        <div className="row justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
          <div className="col-md-6">
            <div className="card border-0 shadow-lg">
              <div className="card-body text-center p-5">
                <div className="display-1 mb-4">🚫</div>
                <h1 className="display-5 fw-bold text-danger mb-3">Acceso Denegado</h1>
                <p className="lead text-muted mb-4">
                  Solo el administrador principal puede acceder a esta sección.
                </p>
                <div className="alert alert-warning">
                  <strong>Usuario actual:</strong> {userData.email || 'No identificado'}
                </div>
                <button 
                  className="btn btn-primary btn-lg"
                  onClick={() => window.location.href = '/'}
                >
                  🏠 Volver al Inicio
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
const handleChange = (e) => {
  const { name, value, type, checked } = e.target;
  
  console.log('=== handleChange EJECUTADO ===');
  console.log('Campo:', name);
  console.log('Valor recibido:', value);
  console.log('Tipo:', typeof value);
  
  // Para checkboxes, usar checked en lugar de value
  if (type === 'checkbox') {
    setForm({ ...form, [name]: checked });
  } else if (name === 'mes_suscripcion' || name === 'dias_adicionales') {
    console.log('Campo numérico - manteniendo como string:', value);
    setForm({ ...form, [name]: value });
  } 
  // ✅ NUEVO: Si cambia el plan a CURSO, limpiar curso_tipo y valor
  else if (name === 'plan') {
    if (value === 'CURSO') {
      setForm({ ...form, [name]: value, curso_tipo: '', valor: '' });
    } else {
      setForm({ ...form, [name]: value, curso_tipo: '' });
    }
  }
  // ✅ NUEVO: Si cambia el tipo de curso, actualizar el valor automáticamente
  else if (name === 'curso_tipo') {
    const precio = calcularPrecioCurso(value);
    setForm({ ...form, [name]: value, valor: precio });
  }
  else {
    setForm({ ...form, [name]: value });
  }
  console.log('===============================');
};

 
// Manejo de cambios en el formulario de pago - CON INDICADOR VISUAL
const handleChangePago = async (e) => {
  const { name, value, type, checked } = e.target;
  
  // Para checkboxes, usar checked en lugar de value
  if (type === 'checkbox') {
    setFormPago({ ...formPago, [name]: checked });
    return;
  }
  
  // ✅ NUEVO: Si cambia el plan a CURSO
  if (name === 'plan') {
    if (value === 'CURSO') {
      setFormPago({ ...formPago, [name]: value, curso_tipo: '', valor: '' });
      return;
    } else {
      setFormPago({ ...formPago, [name]: value, curso_tipo: '' });
    }
  }
  
  // ✅ NUEVO: Si cambia el tipo de curso
  if (name === 'curso_tipo') {
    const precio = calcularPrecioCurso(value);
    setFormPago({ ...formPago, [name]: value, valor: precio });
    return;
  }
  
  // Actualizar el campo normalmente
  setFormPago({ ...formPago, [name]: value });
  
  // Si el campo es celular y tiene al menos 9 dígitos, buscar el correo automáticamente
  if (name === 'celular' && value.length >= 9) {
    try {
      const usuarioEncontrado = usuarios.find(usuario => 
        String(usuario.celular || '').replace(/\D/g, '') === value.replace(/\D/g, '')
      );
      
      if (usuarioEncontrado) {
        console.log('Usuario encontrado por celular:', usuarioEncontrado.correo);
        setFormPago(prev => ({ 
          ...prev, 
          correo: usuarioEncontrado.correo,
          [name]: value 
        }));
        
        setUsuarioEncontrado({
          nombre: usuarioEncontrado.nombre,
          correo: usuarioEncontrado.correo,
          empresa: usuarioEncontrado.empresa
        });
        
        setTimeout(() => setUsuarioEncontrado(null), 3000);
      } else {
        setUsuarioEncontrado(null);
      }
    } catch (error) {
      console.error('Error buscando usuario por celular:', error);
      setUsuarioEncontrado(null);
    }
  } else if (name === 'celular') {
    setUsuarioEncontrado(null);
  }
};

// ✅ NUEVO: Registrar un curso/pago adicional en una cuenta ya existente
// - Agrega el curso nuevo a curso_tipo (sin duplicar)
// - Si el plan está VIGENTE: suma los meses/días al plan actual
// - Si el plan está VENCIDO: reinicia el plan desde hoy
// - Siempre registra la transacción con el monto pagado
const registrarCursoEnCuentaExistente = async (usuarioExistente, datos) => {
  const mesesNuevos = datos.meses === '' || datos.meses === null || datos.meses === undefined ? 0 : parseInt(datos.meses) || 0;
  const diasNuevos = datos.dias === '' || datos.dias === null || datos.dias === undefined ? 0 : parseInt(datos.dias) || 0;
  const valorNuevo = parseFloat(datos.valor) || 0;
  const planVigente = tieneAccesoActivo(usuarioExistente.fecha_fin);

  // Combinar cursos: mantener los existentes y agregar el nuevo si no está
  const cursosActuales = String(usuarioExistente.curso_tipo || '')
    .split(',')
    .map(c => c.trim())
    .filter(Boolean);
  if (datos.plan === 'CURSO' && datos.curso_tipo && !cursosActuales.includes(datos.curso_tipo)) {
    cursosActuales.push(datos.curso_tipo);
  }
  const cursoTipoFinal = cursosActuales.length > 0 ? cursosActuales.join(', ') : null;

  let fechaInicioFinal, mesesFinal, diasFinal, valorFinal;
  if (planVigente) {
    // Plan vigente: se mantiene la fecha de inicio y se acumulan meses/días
    fechaInicioFinal = usuarioExistente.fecha_inicio?.includes('T')
      ? usuarioExistente.fecha_inicio.split('T')[0]
      : (usuarioExistente.fecha_inicio || new Date().toISOString().split('T')[0]);
    mesesFinal = (parseInt(usuarioExistente.mes_suscripcion) || 0) + mesesNuevos;
    diasFinal = (parseInt(usuarioExistente.dias_adicionales) || 0) + diasNuevos;
    valorFinal = (parseFloat(usuarioExistente.valor) || 0) + valorNuevo;
  } else {
    // Plan vencido: se reinicia desde hoy con el tiempo del nuevo curso
    fechaInicioFinal = new Date().toISOString().split('T')[0];
    mesesFinal = mesesNuevos;
    diasFinal = diasNuevos;
    valorFinal = valorNuevo;
  }
  const fechaFinFinal = calcularFechaFin(fechaInicioFinal, mesesFinal, diasFinal);

  await actualizarUsuario(usuarioExistente.correo, {
    plan: datos.plan,
    curso_tipo: cursoTipoFinal,
    valor: valorFinal,
    fecha_inicio: fechaInicioFinal,
    mes_suscripcion: mesesFinal,
    dias_adicionales: diasFinal,
    fecha_fin: fechaFinFinal
  });

  await crearTransaccion({
    correo: usuarioExistente.correo,
    celular: datos.celular || usuarioExistente.celular || '',
    plan: datos.plan,
    valor: valorNuevo,
    medio_pago: datos.medio_pago || null,
    comprobante: datos.comprobante || null,
    cant_meses: mesesNuevos,
    flag_depositado: datos.flag_depositado || false,
    flag_emitido: datos.flag_emitido || false,
    curso_tipo: datos.plan === 'CURSO' ? (datos.curso_tipo || null) : null
  });

  return { planVigente, fechaFin: fechaFinFinal, cursoTipo: cursoTipoFinal };
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    if (form.plan === 'CURSO' && !form.curso_tipo) {
      alert('❌ Error: Debes seleccionar el tipo de curso');
      setLoading(false);
      return;
    }

    const correoExiste = await verificarCorreoExiste(form.correo);
    if (correoExiste) {
      // ✅ NUEVO: El alumno ya tiene cuenta → registrar el nuevo curso/pago sobre la cuenta existente
      let usuarioExistente = usuarios.find(u => u.correo === form.correo);
      if (!usuarioExistente) {
        const usuariosActuales = await obtenerUsuarios();
        usuarioExistente = usuariosActuales.find(u => u.correo === form.correo);
      }
      if (!usuarioExistente) {
        alert('❌ Error: El correo ya existe pero no se pudo cargar la cuenta. Actualiza la lista e intenta de nuevo.');
        setLoading(false);
        return;
      }

      const planVigente = tieneAccesoActivo(usuarioExistente.fecha_fin);
      const confirmar = window.confirm(
        `⚠️ Este correo ya tiene una cuenta creada:\n\n` +
        `👤 ${usuarioExistente.nombre || '-'}\n` +
        `🗂️ Plan actual: ${usuarioExistente.plan || '-'}${usuarioExistente.curso_tipo ? ` (${usuarioExistente.curso_tipo})` : ''}\n` +
        `🏁 Fin actual: ${usuarioExistente.fecha_fin ? new Date(usuarioExistente.fecha_fin).toLocaleDateString('es-PE') : '-'}\n\n` +
        (planVigente
          ? `✅ Su plan está VIGENTE: los meses/días ingresados se AGREGARÁN a su plan actual.\n\n`
          : `🔴 Su plan está VENCIDO: el plan se REINICIARÁ desde hoy con los meses/días ingresados.\n\n`) +
        `¿Deseas registrar el nuevo curso/pago en esta cuenta?`
      );
      if (!confirmar) {
        setLoading(false);
        return;
      }

      const resultado = await registrarCursoEnCuentaExistente(usuarioExistente, {
        plan: form.plan,
        curso_tipo: form.curso_tipo,
        valor: form.valor,
        meses: form.mes_suscripcion,
        dias: form.dias_adicionales,
        celular: form.celular,
        medio_pago: form.medio_pago,
        comprobante: form.comprobante,
        flag_depositado: form.flag_depositado,
        flag_emitido: form.flag_emitido
      });

      alert(
        `✅ Curso/pago registrado en la cuenta existente\n\n` +
        (resultado.cursoTipo ? `🎓 Cursos: ${resultado.cursoTipo}\n` : '') +
        `📅 Plan ${resultado.planVigente ? 'extendido (tiempo agregado al plan vigente)' : 'reiniciado desde hoy'}\n` +
        `🏁 Nueva fecha fin: ${new Date(resultado.fechaFin).toLocaleDateString('es-PE')}`
      );

      // Limpiar formulario y recargar datos
      setForm({
        celular: '',
        correo: '',
        nombre: '',
        empresa: '',
        plan: '',
        ruc: '',
        valor: '',
        fecha_inicio: '',
        mes_suscripcion: '',
        dias_adicionales: '',
        fecha_fin: '',
        comentarios: '',
        medio_pago: '',
        comprobante: '',
        flag_depositado: false,
        flag_emitido: false,
        curso_tipo: ''
      });
      await cargarUsuarios();
      await cargarEstadisticas();
      await cargarTransacciones();
      await cargarEstadisticasTransacciones();
      setActiveTab('usuarios');
      return;
    }

    // PASO 1: Preparar datos SOLO para tabla USUARIOS
    const usuarioData = {
      celular: form.celular,
      correo: form.correo,
      nombre: form.nombre,
      empresa: form.empresa,
      plan: form.plan,
      ruc: form.ruc,
      valor: parseFloat(form.valor) || 0,
      fecha_inicio: form.fecha_inicio,
      mes_suscripcion: form.mes_suscripcion === '' || form.mes_suscripcion === null || form.mes_suscripcion === undefined ? 0 : parseInt(form.mes_suscripcion),
      dias_adicionales: form.dias_adicionales === '' || form.dias_adicionales === null || form.dias_adicionales === undefined ? 0 : parseInt(form.dias_adicionales),
      comentarios: form.comentarios,
      // Campos automáticos para usuarios
      curso_tipo: form.curso_tipo || null, 
      flag_correo: 'SI',
      palabras_claves: 'ALL',
      departamentos: 'ALL',
      tipo: 'ALL',
      flag_sunat: 'NO'
    };

    // Calcular fecha_fin para usuarios
    usuarioData.fecha_fin = calcularFechaFin(
      usuarioData.fecha_inicio,
      usuarioData.mes_suscripcion,
      usuarioData.dias_adicionales
    );

    console.log('=== DATOS PARA TABLA USUARIOS ===');
    console.log(usuarioData);
    console.log('=================================');
    
    // CREAR USUARIO en tabla usuarios
    await crearUsuario(usuarioData);

    // Contraseña de acceso del cliente nuevo: se genera y se copia al portapapeles.
    // Si algo falla aquí, el usuario ya quedó creado y entra con su RUC.
    let claveNueva = null;
    let claveCopiada = false;
    try {
      claveNueva = await generarClaveUsuario(usuarioData.correo);
      claveCopiada = await copiarCredenciales(usuarioData.correo, claveNueva, ENCABEZADO_USUARIO_NUEVO);
      setClaveGenerada({
        correo: usuarioData.correo, nombre: usuarioData.nombre,
        clave: claveNueva, copiado: claveCopiada, recienCreado: true
      });
    } catch (errorClave) {
      console.error('No se pudo generar la contraseña:', errorClave);
      setClaveGenerada({
        correo: usuarioData.correo, nombre: usuarioData.nombre,
        error: errorClave.message, recienCreado: true
      });
    }

    // PASO 2: SIEMPRE crear una transacción (modificado)
    const transaccionData = {
      correo: form.correo,
      celular: form.celular,
      plan: form.plan,
      valor: parseFloat(form.valor) || 0,
      medio_pago: form.medio_pago || null,  // Puede ser null si no se seleccionó
      comprobante: form.comprobante || null,  // Puede ser null si no se seleccionó
      cant_meses: usuarioData.mes_suscripcion,  
      flag_depositado: form.flag_depositado,
      flag_emitido: form.flag_emitido,
      curso_tipo: form.curso_tipo || null 
    };
    
    console.log('=== DATOS PARA TABLA TRANSACCIONES (SIEMPRE) ===');
    console.log('flag_depositado:', transaccionData.flag_depositado, typeof transaccionData.flag_depositado);
    console.log('flag_emitido:', transaccionData.flag_emitido, typeof transaccionData.flag_emitido);
    console.log('Objeto completo:', transaccionData);
    console.log('===============================================');
    
    await crearTransaccion(transaccionData);

    // El mensaje con la contraseña ya quedó en el portapapeles al generarla. No se
    // vuelve a escribir sobre él: antes se copiaba aquí un segundo mensaje (el del
    // código único) que borraba la clave recién copiada.
    if (claveNueva) {
      alert(
        `✅ Usuario registrado correctamente\n\n` +
        `👤 ${usuarioData.correo}\n` +
        `🔑 Contraseña: ${claveNueva}\n\n` +
        (claveCopiada
          ? '📋 El mensaje con las credenciales ya está en el portapapeles: solo haz Ctrl+V para pegarlo.'
          : 'El navegador no dejó copiarlo solo: usa el botón "📋 Copiar mensaje" del aviso que quedó arriba.')
      );
    } else {
      alert(
        '✅ Usuario registrado correctamente\n\n' +
        'No se pudo generar su contraseña: puede entrar con su RUC, o genérala con el botón 🔑 Clave de su fila.'
      );
    }
    // El aviso con la contraseña se muestra arriba del todo: si el formulario quedó
    // desplazado, no se vería al cerrar el alert.
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Limpiar formulario
    setForm({
      celular: '',
      correo: '',
      nombre: '',
      empresa: '',
      plan: '',
      ruc: '',
      valor: '',
      fecha_inicio: '',
      mes_suscripcion: '',
      dias_adicionales: '',
      fecha_fin: '',
      comentarios: '',
      medio_pago: '',
      comprobante: '',
      flag_depositado: false,
      flag_emitido: false,
      curso_tipo: ''
    });
    
    await cargarUsuarios();
    await cargarEstadisticas();
    await cargarTransacciones();  
    await cargarEstadisticasTransacciones(); 
    setActiveTab('usuarios');
    
  } catch (error) {
    console.error('Error:', error);
    alert(`❌ Error al registrar usuario: ${error.message}`);
  } finally {
    setLoading(false);
  }
};

  // Pegar desde Excel en la tabla de grupo
  const CAMPOS_TABLA_GRUPO = ['nombre', 'correo', 'celular', 'empresa', 'ruc', 'comentarios', 'comprobante'];
  const handlePasteGrupo = (e, idx, field) => {
    const text = e.clipboardData.getData('text');
    if (!text.includes('\n') && !text.includes('\t')) return;
    e.preventDefault();
    const filas = text.split('\n').map(r => r.replace(/\r$/, '')).filter(r => r !== '');
    const fieldIdx = CAMPOS_TABLA_GRUPO.indexOf(field);
    setUsuariosGrupo(prev => {
      let updated = [...prev];
      filas.forEach((fila, rowOffset) => {
        const cols = fila.split('\t');
        const targetIdx = idx + rowOffset;
        while (updated.length <= targetIdx) {
          updated.push({ id: Date.now() + updated.length, nombre: '', correo: '', celular: '', empresa: '', ruc: '', comentarios: '', comprobante: '', valor: '', dias_extra: '', flag_emitido: configGrupo.flag_emitido, flag_depositado: configGrupo.flag_depositado });
        }
        cols.forEach((val, colOffset) => {
          const targetField = CAMPOS_TABLA_GRUPO[fieldIdx + colOffset];
          if (targetField) updated[targetIdx] = { ...updated[targetIdx], [targetField]: val.trim() };
        });
      });
      return updated;
    });
  };

  // Creación de usuarios en grupo
  const handleCrearGrupo = async () => {
    const validos = usuariosGrupo.filter(u => u.nombre.trim() && u.correo.trim());
    if (validos.length === 0) {
      alert('❌ Debes completar al menos un usuario con nombre y correo');
      return;
    }
    if (!configGrupo.plan) {
      alert('❌ Debes seleccionar un plan');
      return;
    }
    if (!configGrupo.fecha_inicio) {
      alert('❌ Debes ingresar la fecha de inicio');
      return;
    }
    setLoadingGrupo(true);
    const resultados = [];
    const meses = parseInt(configGrupo.mes_suscripcion) || 0;
    const dias = parseInt(configGrupo.dias_adicionales) || 0;

    for (const u of validos) {
      try {
        // Monto individual del alumno si se especificó; si no, el valor general del grupo
        const valorUsuario = (u.valor !== '' && u.valor != null)
          ? (parseFloat(u.valor) || 0)
          : (parseFloat(configGrupo.valor) || 0);

        // Días extra de este alumno: se SUMAN a la duración general del grupo, no
        // la reemplazan. Sirve para el que entra tarde o lleva una cortesía.
        const diasUsuario = dias + (parseInt(u.dias_extra) || 0);
        const fechaFinUsuario = calcularFechaFin(configGrupo.fecha_inicio, meses, diasUsuario);

        const correoExiste = await verificarCorreoExiste(u.correo.trim());
        if (correoExiste) {
          // ✅ NUEVO: cuenta existente → agregar el curso y extender/reiniciar su plan
          let usuarioExistente = usuarios.find(x => x.correo === u.correo.trim());
          if (!usuarioExistente) {
            const usuariosActuales = await obtenerUsuarios();
            usuarioExistente = usuariosActuales.find(x => x.correo === u.correo.trim());
          }
          if (!usuarioExistente) {
            resultados.push({ ...u, ok: false, error: 'El correo ya existe pero no se pudo cargar la cuenta' });
            continue;
          }
          const resultado = await registrarCursoEnCuentaExistente(usuarioExistente, {
            plan: configGrupo.plan,
            curso_tipo: configGrupo.plan === 'CURSO' ? configGrupo.curso_tipo : null,
            valor: valorUsuario,
            meses: meses,
            dias: diasUsuario,
            celular: u.celular.trim() || usuarioExistente.celular,
            medio_pago: configGrupo.medio_pago,
            comprobante: u.comprobante || configGrupo.comprobante,
            flag_depositado: u.flag_depositado,
            flag_emitido: u.flag_emitido
          });
          // A una cuenta que ya existe no se le genera contraseña nueva: la que tiene
          // sigue sirviendo y regenerarla le cortaría el acceso.
          const mensajeExistente = plantillaMensaje
            .replace(/\{correo\}/g, u.correo.trim())
            .replace(/\{codigo\}/g, u.ruc.trim() || usuarioExistente.ruc || '-')
            .replace(/\{clave\}/g, 'la que ya venías usando')
            .replace(/\{nombre\}/g, u.nombre.trim() || usuarioExistente.nombre || '-')
            .replace(/\{empresa\}/g, u.empresa.trim() || usuarioExistente.empresa || '-');
          resultados.push({
            ...u,
            ok: true,
            mensaje: mensajeExistente,
            nota: `Curso agregado a cuenta existente — plan ${resultado.planVigente ? 'extendido' : 'reiniciado desde hoy'} hasta ${new Date(resultado.fechaFin).toLocaleDateString('es-PE')}`
          });
          continue;
        }
        const usuarioData = {
          nombre: u.nombre.trim(),
          correo: u.correo.trim(),
          celular: u.celular.trim(),
          empresa: u.empresa.trim(),
          plan: configGrupo.plan,
          ruc: u.ruc.trim(),
          valor: valorUsuario,
          fecha_inicio: configGrupo.fecha_inicio,
          mes_suscripcion: meses,
          dias_adicionales: diasUsuario,
          fecha_fin: fechaFinUsuario,
          comentarios: u.comentarios.trim(),
          curso_tipo: configGrupo.plan === 'CURSO' ? configGrupo.curso_tipo : null,
          flag_correo: 'SI',
          palabras_claves: 'ALL',
          departamentos: 'ALL',
          tipo: 'ALL',
          flag_sunat: 'NO'
        };
        await crearUsuario(usuarioData);

        // Contraseña de acceso del cliente nuevo, para que el mensaje ya la lleve.
        // Si falla, el usuario queda creado y se le genera con el botón 🔑 de su fila.
        let claveNueva = null;
        try {
          claveNueva = await generarClaveUsuario(u.correo.trim());
        } catch (errorClave) {
          console.error('No se pudo generar la contraseña de ' + u.correo.trim() + ':', errorClave);
        }

        await crearTransaccion({
          correo: u.correo.trim(),
          celular: u.celular.trim(),
          plan: configGrupo.plan,
          valor: valorUsuario,
          medio_pago: configGrupo.medio_pago || null,
          comprobante: u.comprobante || configGrupo.comprobante || null,
          cant_meses: meses,
          flag_depositado: u.flag_depositado,
          flag_emitido: u.flag_emitido,
          curso_tipo: configGrupo.plan === 'CURSO' ? configGrupo.curso_tipo : null
        });
        const mensaje = plantillaMensaje
          .replace(/\{correo\}/g, u.correo.trim())
          .replace(/\{codigo\}/g, u.ruc.trim() || '-')
          .replace(/\{clave\}/g, claveNueva || '(pendiente)')
          .replace(/\{nombre\}/g, u.nombre.trim())
          .replace(/\{empresa\}/g, u.empresa.trim() || '-');
        resultados.push({
          ...u,
          ok: true,
          mensaje,
          clave: claveNueva,
          claveFallo: !claveNueva,
          nota: claveNueva ? null : 'Creado, pero sin contraseña: genérala con el botón 🔑 Clave de su fila'
        });
      } catch (error) {
        resultados.push({ ...u, ok: false, error: error.message });
      }
    }
    setResultadosGrupo(resultados);
    setMostrarResultadosGrupo(true);
    setLoadingGrupo(false);
    await cargarUsuarios();
    await cargarEstadisticas();
    await cargarTransacciones();
    await cargarEstadisticasTransacciones();
  };

  // Envío del formulario de pago
  const handleSubmitPago = async (e) => {
    e.preventDefault();
    setLoadingPago(true);
    
  try {
    // ✅ VALIDACIÓN: Si es CURSO, verificar que se haya seleccionado el tipo
    if (formPago.plan === 'CURSO' && !formPago.curso_tipo) {
      alert('❌ Error: Debes seleccionar el tipo de curso');
      setLoadingPago(false);
      return;
    }

    const transaccionData = {
      ...formPago,
      curso_tipo: formPago.curso_tipo || null // ✅ NUEVO
    };

    await crearTransaccion(transaccionData);
      
      alert('✅ Pago registrado correctamente');
      
      setFormPago({
        celular: '',
        correo: '',
        plan: '',
        valor: '',
        medio_pago: '',
        comprobante: '',
        cant_meses: '',
          flag_depositado: false,
  flag_emitido: false,
  curso_tipo:''
      });
      setUsuarioEncontrado(null);
      await cargarTransacciones();
      await cargarEstadisticasTransacciones();
      
    } catch (error) {
      console.error('Error:', error);
      alert(`❌ Error al registrar pago: ${error.message}`);
    } finally {
      setLoadingPago(false);
    }
  };

  const generarClaveHandler = async (usuario) => {
    try {
      const clave = await generarClaveUsuario(usuario.correo);
      const copiado = await copiarCredenciales(usuario.correo, clave);
      setClaveGenerada({ correo: usuario.correo, nombre: usuario.nombre, clave, copiado });
    } catch (error) {
      setClaveGenerada({ correo: usuario.correo, nombre: usuario.nombre, error: error.message });
    }
  };

  // Eliminar usuario
  const eliminarUsuarioHandler = async (correoUsuario, nombreUsuario) => {
    const confirmacion = window.confirm(
      `¿Estás seguro de que quieres eliminar al usuario "${nombreUsuario}"?\n\nEsta acción no se puede deshacer.`
    );
    
    if (!confirmacion) return;

    try {
      await eliminarUsuario(correoUsuario);
      alert('✅ Usuario eliminado correctamente');
      await cargarUsuarios();
      await cargarEstadisticas();
    } catch (error) {
      console.error('Error:', error);
      alert(`❌ Error al eliminar usuario: ${error.message}`);
    }
  };

// Función iniciarEdicion mejorada
const iniciarEdicion = (usuario) => {
  setEditingUser(usuario.correo);
  
  // Preparar datos iniciales limpios
  const editDataInicial = {
    celular: usuario.celular || '',
    correo: usuario.correo || '',
    nombre: usuario.nombre || '',
    empresa: usuario.empresa || '',
    plan: usuario.plan || '',
    ruc: usuario.ruc || '',
    valor: parseFloat(usuario.valor) || 0,
    comentarios: usuario.comentarios || '',
    notificado: usuario.notificado || false,
    // Limpiar la fecha de inicio (quitar la parte de tiempo si existe)
    fecha_inicio: usuario.fecha_inicio?.includes('T') ? 
      usuario.fecha_inicio.split('T')[0] : (usuario.fecha_inicio || ''),
    mes_suscripcion: parseInt(usuario.mes_suscripcion) || 0,
    dias_adicionales: parseInt(usuario.dias_adicionales) || 0,
  };
  
  // Recalcular fecha_fin con los datos limpios
  editDataInicial.fecha_fin = calcularFechaFin(
    editDataInicial.fecha_inicio,
    editDataInicial.mes_suscripcion,
    editDataInicial.dias_adicionales
  );
  
  console.log('=== INICIANDO EDICIÓN ===');
  console.log('Usuario:', usuario.nombre);
  console.log('Datos iniciales:', editDataInicial);
  console.log('========================');
  
  setEditData(editDataInicial);
};

  const cancelarEdicion = () => {
    setEditingUser(null);
    setEditData({});
  };

// Función manejarCambioEdicion mejorada
const manejarCambioEdicion = (campo, valor) => {
  setEditData(prev => {
    const newData = { ...prev };
    
    // Actualizar el campo específico
    if (campo === 'mes_suscripcion' || campo === 'dias_adicionales') {
      newData[campo] = parseInt(valor) || 0;
    } else {
      newData[campo] = valor;
    }
    
    // Si cambió algún campo que afecta la fecha fin, recalcularla
    if (['fecha_inicio', 'mes_suscripcion', 'dias_adicionales'].includes(campo)) {
      const fechaFinCalculada = calcularFechaFin(
        newData.fecha_inicio, 
        newData.mes_suscripcion || 0, 
        newData.dias_adicionales || 0
      );
      newData.fecha_fin = fechaFinCalculada;
      
      console.log('=== RECÁLCULO EN TIEMPO REAL ===');
      console.log('Campo modificado:', campo);
      console.log('Nuevo valor:', valor);
      console.log('Fecha inicio:', newData.fecha_inicio);
      console.log('Meses:', newData.mes_suscripcion);
      console.log('Días:', newData.dias_adicionales);
      console.log('Fecha fin:', fechaFinCalculada);
      console.log('================================');
    }
    
    return newData;
  });
};

// Función guardarEdicion corregida
const guardarEdicion = async () => {
  try {
    // Crear una copia limpia de los datos
    const dataToUpdate = {
      celular: editData.celular || '',
      correo: editData.correo || '',
      nombre: editData.nombre || '',
      empresa: editData.empresa || '',
      plan: editData.plan || '',
      ruc: editData.ruc || '',
      comentarios: editData.comentarios || '',
      fecha_inicio: editData.fecha_inicio || '',
      notificado: editData.notificado || false,
    };
    
    // Asegurar tipos de datos correctos para campos numéricos
    dataToUpdate.mes_suscripcion = parseInt(editData.mes_suscripcion) || 0;
    dataToUpdate.dias_adicionales = parseInt(editData.dias_adicionales) || 0;
    dataToUpdate.valor = parseFloat(editData.valor) || 0;
    
    // IMPORTANTE: Recalcular fecha_fin justo antes de enviar
    // Esto asegura que use los valores más actuales
    dataToUpdate.fecha_fin = calcularFechaFin(
      dataToUpdate.fecha_inicio,
      dataToUpdate.mes_suscripcion,
      dataToUpdate.dias_adicionales
    );
    
    console.log('=== DATOS ANTES DE ACTUALIZAR ===');
    console.log('Fecha inicio:', dataToUpdate.fecha_inicio);
    console.log('Meses:', dataToUpdate.mes_suscripcion);
    console.log('Días adicionales:', dataToUpdate.dias_adicionales);
    console.log('Fecha fin calculada:', dataToUpdate.fecha_fin);
    console.log('================================');
    
    await actualizarUsuario(editingUser, dataToUpdate);
    alert('✅ Usuario actualizado correctamente');
    setEditingUser(null);
    setEditData({});
    await cargarUsuarios();
    await cargarEstadisticas();
  } catch (error) {
    console.error('Error completo:', error);
    alert(`❌ Error al actualizar usuario: ${error.message}`);
  }
};

// ===== EDICIÓN MASIVA =====
// Calcula la nueva vigencia al sumar meses/días.
// - Plan VIGENTE: se mantiene la fecha de inicio y se acumulan meses/días (extiende).
// - Plan VENCIDO: se reinicia desde hoy con los meses/días indicados (renueva).
const calcularExtensionUsuario = (usuario, addMeses, addDias) => {
  const vigente = tieneAccesoActivo(usuario.fecha_fin);
  const mesesAdd = parseInt(addMeses) || 0;
  const diasAdd = parseInt(addDias) || 0;
  let fechaInicio, meses, dias;
  if (vigente) {
    fechaInicio = usuario.fecha_inicio?.includes('T')
      ? usuario.fecha_inicio.split('T')[0]
      : (usuario.fecha_inicio || new Date().toISOString().split('T')[0]);
    meses = (parseInt(usuario.mes_suscripcion) || 0) + mesesAdd;
    dias = (parseInt(usuario.dias_adicionales) || 0) + diasAdd;
  } else {
    fechaInicio = new Date().toISOString().split('T')[0];
    meses = mesesAdd;
    dias = diasAdd;
  }
  return {
    vigente,
    fecha_inicio: fechaInicio,
    mes_suscripcion: meses,
    dias_adicionales: dias,
    fecha_fin: calcularFechaFin(fechaInicio, meses, dias)
  };
};

const getBulkAdd = (correo) => bulkAdd[correo] || { meses: '', dias: '' };

const setBulkAddCampo = (correo, campo, valor) => {
  setBulkAdd(prev => ({
    ...prev,
    [correo]: { ...(prev[correo] || { meses: '', dias: '' }), [campo]: valor }
  }));
};

const toggleBulkSeleccion = (correo) => {
  setBulkSelected(prev => ({ ...prev, [correo]: !prev[correo] }));
};

const toggleBulkSeleccionTodos = (lista) => {
  const todosSeleccionados = lista.length > 0 && lista.every(u => bulkSelected[u.correo]);
  if (todosSeleccionados) {
    setBulkSelected({});
  } else {
    const nuevo = {};
    lista.forEach(u => { nuevo[u.correo] = true; });
    setBulkSelected(nuevo);
  }
};

const aplicarTiempoASeleccionados = () => {
  const seleccionados = Object.keys(bulkSelected).filter(c => bulkSelected[c]);
  if (seleccionados.length === 0) {
    alert('❌ Marca al menos un usuario con la casilla');
    return;
  }
  if ((parseInt(bulkMeses) || 0) === 0 && (parseInt(bulkDias) || 0) === 0) {
    alert('❌ Ingresa cuántos meses o días quieres agregar');
    return;
  }
  setBulkAdd(prev => {
    const next = { ...prev };
    seleccionados.forEach(correo => {
      next[correo] = { meses: bulkMeses || '', dias: bulkDias || '' };
    });
    return next;
  });
};

const limpiarCambiosMasivos = () => {
  setBulkAdd({});
  setBulkSelected({});
  setBulkMeses('');
  setBulkDias('');
};

// Cuántos usuarios tienen cambios pendientes (meses o días > 0)
const contarCambiosPendientes = () =>
  Object.values(bulkAdd).filter(v => (parseInt(v.meses) || 0) > 0 || (parseInt(v.dias) || 0) > 0).length;

const guardarCambiosMasivos = async () => {
  const correosConCambios = Object.keys(bulkAdd).filter(correo => {
    const v = bulkAdd[correo];
    return (parseInt(v.meses) || 0) > 0 || (parseInt(v.dias) || 0) > 0;
  });
  if (correosConCambios.length === 0) {
    alert('❌ No hay cambios para guardar. Agrega meses o días a los usuarios.');
    return;
  }
  if (!window.confirm(`¿Aplicar la extensión de tiempo a ${correosConCambios.length} usuario(s)?`)) return;

  setSavingBulk(true);
  const errores = [];
  let exitosos = 0;
  for (const correo of correosConCambios) {
    try {
      const usuario = usuarios.find(u => u.correo === correo);
      if (!usuario) { errores.push(`${correo} (no encontrado)`); continue; }
      const { meses, dias } = bulkAdd[correo];
      const ext = calcularExtensionUsuario(usuario, meses, dias);
      await actualizarUsuario(correo, {
        fecha_inicio: ext.fecha_inicio,
        mes_suscripcion: ext.mes_suscripcion,
        dias_adicionales: ext.dias_adicionales,
        fecha_fin: ext.fecha_fin
      });
      exitosos++;
    } catch (error) {
      console.error('Error actualizando', correo, error);
      errores.push(`${correo} (${error.message})`);
    }
  }
  setSavingBulk(false);
  await cargarUsuarios();
  await cargarEstadisticas();
  limpiarCambiosMasivos();
  if (errores.length === 0) {
    alert(`✅ ${exitosos} usuario(s) actualizados correctamente`);
  } else {
    alert(`⚠️ Actualizados: ${exitosos}\n❌ Con error: ${errores.length}\n\n${errores.join('\n')}`);
  }
};

// Funciones para editar transacciones
const iniciarEdicionTransaccion = (transaccion) => {
  setEditingTransaction(transaccion.id);
  setEditTransactionData({
    correo: transaccion.correo || '',
    celular: transaccion.celular || '',
    plan: transaccion.plan || '',
    valor: parseFloat(transaccion.valor) || 0,
    medio_pago: transaccion.medio_pago || '',
    comprobante: transaccion.comprobante || '',
    cant_meses: parseInt(transaccion.cant_meses) || 0,
    flag_depositado: transaccion.flag_depositado || false,
    flag_emitido: transaccion.flag_emitido || false
  });
};

const cancelarEdicionTransaccion = () => {
  setEditingTransaction(null);
  setEditTransactionData({});
};

const manejarCambioEdicionTransaccion = (campo, valor) => {
  setEditTransactionData(prev => ({
    ...prev,
    [campo]: valor
  }));
};
// Función para renderizar celda editable de transacción
const renderEditableCellTransaction = (transaccion, campo, tipo = 'text') => {
  const isEditing = editingTransaction === transaccion.id;
  const displayValue = transaccion[campo] || '';
  
  if (campo === 'flag_depositado' || campo === 'flag_emitido') {
    if (!isEditing) {
      return displayValue ? 
        <span className="badge bg-success">✅ Sí</span> : 
        <span className="badge bg-secondary">❌ No</span>;
    }
    
    return (
      <input
        type="checkbox"
        className="form-check-input"
        checked={editTransactionData[campo] || false}
        onChange={(e) => manejarCambioEdicionTransaccion(campo, e.target.checked)}
        style={{ transform: 'scale(1.2)' }}
      />
    );
  }
  
  if (!isEditing) {
    if (tipo === 'number' && campo === 'valor') {
      return `S/. ${displayValue?.toLocaleString() || '0'}`;
    }
    if (campo === 'medio_pago') {
      return displayValue?.replace('_', ' ') || '';
    }
    return displayValue || '';
  }

  if (campo === 'plan') {
    return (
      <select
        className="form-select form-select-sm"
        value={editTransactionData[campo] || ''}
        onChange={(e) => manejarCambioEdicionTransaccion(campo, e.target.value)}
      >
        <option value="">Seleccionar...</option>
        <option value="MENOR">MENOR</option>
        <option value="PAC">PAC</option>
        <option value="PREMIUM">PREMIUM</option>
        <option value="PLUS_PLUS">PLAN PLUS+</option>
        <option value="CURSO">CURSO</option>
              <option value="MENORES_OLD">MENORES OLD</option>
      <option value="MAYORES_OLD">MAYORES OLD</option>
        <option value="ADMI">ADMI</option>
      </select>
    );
  }

  if (campo === 'medio_pago') {
    return (
      <select
        className="form-select form-select-sm"
        value={editTransactionData[campo] || ''}
        onChange={(e) => manejarCambioEdicionTransaccion(campo, e.target.value)}
      >
        <option value="">Seleccionar...</option>
        <option value="TARJETA_CREDITO">Tarjeta de Crédito</option>
        <option value="TARJETA_DEBITO">Tarjeta de Débito</option>
        <option value="TRANSFERENCIA">Transferencia Bancaria</option>
        <option value="YAPE">Yape</option>
        <option value="PLIN">Plin</option>
        <option value="EFECTIVO">Efectivo</option>
      </select>
    );
  }

  if (campo === 'comprobante') {
    return (
      <select
        className="form-select form-select-sm"
        value={editTransactionData[campo] || ''}
        onChange={(e) => manejarCambioEdicionTransaccion(campo, e.target.value)}
      >
        <option value="">Seleccionar...</option>
        <option value="FACTURA">FACTURA</option>
        <option value="BOLETA ELECTRONICA">BOLETA ELECTRONICA</option>
        <option value="SIN COMPROBANTE">SIN COMPROBANTE</option>
      </select>
    );
  }

  return (
    <input
      type={tipo}
      className="form-control form-control-sm"
      value={editTransactionData[campo] !== undefined ? editTransactionData[campo] : ''}
      onChange={(e) => manejarCambioEdicionTransaccion(campo, e.target.value)}
      style={{ minWidth: '120px' }}
    />
  );
};
const guardarEdicionTransaccion = async () => {
  try {
    const dataToUpdate = {
      correo: editTransactionData.correo || '',
      celular: editTransactionData.celular || '',
      plan: editTransactionData.plan || '',
      valor: parseFloat(editTransactionData.valor) || 0,
      medio_pago: editTransactionData.medio_pago || '',
      comprobante: editTransactionData.comprobante || '',
      cant_meses: parseInt(editTransactionData.cant_meses) || 0,
      flag_depositado: editTransactionData.flag_depositado || false,
      flag_emitido: editTransactionData.flag_emitido || false
    };
    
    await actualizarTransaccion(editingTransaction, dataToUpdate);
    
    // ✅ Actualizar el estado local directamente sin recargar todo
    setTransacciones(prevTransacciones => 
      prevTransacciones.map(t => 
        t.id === editingTransaction 
          ? { ...t, ...dataToUpdate, updated_at: new Date().toISOString() }
          : t
      )
    );
    
    // ✅ Cerrar el modo de edición
    setEditingTransaction(null);
    setEditTransactionData({});
    
    // ✅ Mostrar mensaje de éxito
    alert('✅ Transacción actualizada correctamente');
    
    // ✅ Solo recargar estadísticas (más rápido)
    await cargarEstadisticasTransacciones();
    
  } catch (error) {
    console.error('Error:', error);
    alert(`❌ Error al actualizar transacción: ${error.message}`);
    // Si hay error, recargar todo para mantener consistencia
    await cargarTransacciones();
    await cargarEstadisticasTransacciones();
  }
};
// Filtrar y ordenar usuarios
const usuariosFiltrados = usuarios.filter(usuario => {
  try {
    // Convertir todo a string de forma segura
    const nombre = String(usuario.nombre || '').toLowerCase();
    const correo = String(usuario.correo || '').toLowerCase();
    const empresa = String(usuario.empresa || '').toLowerCase();
    const celular = String(usuario.celular || '');
    const busquedaLower = String(busqueda || '').toLowerCase();
    
    const cumpleBusqueda = nombre.includes(busquedaLower) ||
                          correo.includes(busquedaLower) ||
                          empresa.includes(busquedaLower) ||
                          celular.includes(busqueda);
    
    if (!cumpleBusqueda) return false;

    // Filtro por estado (vigente, vencido, etc.)
    let cumpleFiltroEstado = true;
    switch (filtro) {
      case 'vigentes':
        cumpleFiltroEstado = (usuario.dias_restantes || 0) > 5;
        break;
      case 'vencidos':
        cumpleFiltroEstado = (usuario.dias_restantes || 0) < 0;
        break;
      case 'proximos':
        cumpleFiltroEstado = (usuario.dias_restantes || 0) >= 0 && (usuario.dias_restantes || 0) <= 5;
        break;
      case 'hoy':
        cumpleFiltroEstado = (usuario.dias_restantes || 0) === 0;
        break;
      default:
        cumpleFiltroEstado = true;
    }
    
    if (!cumpleFiltroEstado) return false;

    // Filtro por plan
    if (filtroPlan !== 'todos') {
      const planUsuario = String(usuario.plan || '').toUpperCase();
      if (planUsuario !== filtroPlan) return false;
    }

    // Filtro por grupo de curso (solo aplica cuando filtroPlan es CURSO)
    // El usuario puede tener varios cursos separados por coma
    if (filtroPlan === 'CURSO' && filtroGrupo !== 'todos') {
      const gruposUsuario = String(usuario.curso_tipo || '')
        .toUpperCase()
        .split(',')
        .map(c => c.trim());
      if (!gruposUsuario.includes(filtroGrupo)) return false;
    }

    return true;
  } catch (error) {
    console.error('Error en filtrado de usuario:', error, usuario);
    return true;
  }
}).sort((a, b) => {
  if (filtro === 'vencidos') {
    const diasA = a.dias_restantes || 0;
    const diasB = b.dias_restantes || 0;
    // 'recientes': menos días vencido primero (ej: -1 antes que -30)
    // 'antiguos': más días vencido primero (ej: -30 antes que -1)
    return sortVencidos === 'recientes' ? diasB - diasA : diasA - diasB;
  }
  return 0;
});
  // Lista para el panel de edición masiva (filtros propios del modal: búsqueda, plan y estado)
  const bulkUsuarios = usuarios.filter(u => {
    // Búsqueda por texto
    if (bulkBusqueda) {
      const q = String(bulkBusqueda).toLowerCase();
      const coincide = String(u.nombre || '').toLowerCase().includes(q) ||
                       String(u.correo || '').toLowerCase().includes(q) ||
                       String(u.empresa || '').toLowerCase().includes(q) ||
                       String(u.celular || '').includes(bulkBusqueda);
      if (!coincide) return false;
    }
    // Filtro por plan
    if (bulkFiltroPlan !== 'todos') {
      if (String(u.plan || '').toUpperCase() !== bulkFiltroPlan) return false;
    }
    // Filtro por grupo de curso (solo aplica cuando el plan es CURSO)
    // El alumno puede tener varios cursos separados por coma
    if (bulkFiltroPlan === 'CURSO' && bulkFiltroGrupo !== 'todos') {
      const gruposUsuario = String(u.curso_tipo || '')
        .toUpperCase()
        .split(',')
        .map(c => c.trim());
      if (!gruposUsuario.includes(bulkFiltroGrupo)) return false;
    }
    // Filtro por estado (según días restantes)
    if (bulkFiltroEstado !== 'todos') {
      const dias = u.dias_restantes || 0;
      switch (bulkFiltroEstado) {
        case 'vigentes': if (!(dias > 5)) return false; break;
        case 'proximos': if (!(dias >= 0 && dias <= 5)) return false; break;
        case 'hoy': if (dias !== 0) return false; break;
        case 'vencidos': if (!(dias < 0)) return false; break;
        default: break;
      }
    }
    return true;
  });
  // Filtrar transacciones
  const transaccionesFiltradas = transacciones.filter(transaccion => {
    return String(transaccion.celular || '').includes(busquedaTransacciones) ||
           transaccion.correo?.toLowerCase().includes(busquedaTransacciones.toLowerCase()) ||
           transaccion.plan?.toLowerCase().includes(busquedaTransacciones.toLowerCase()) ||
           transaccion.comprobante?.toLowerCase().includes(busquedaTransacciones.toLowerCase());
  });

  // Obtener el color del estado
  const getEstadoColor = (diasRestantes) => {
    if (diasRestantes < 0) return 'text-danger';
    if (diasRestantes <= 5) return 'text-warning';
    return 'text-success';
  };

  // Obtener el badge del estado
  const getEstadoBadge = (diasRestantes) => {
    if (diasRestantes < 0) return <span className="badge bg-danger shadow-sm">🔴 Vencido</span>;
    if (diasRestantes === 0) return <span className="badge bg-warning shadow-sm">⚠️ Vence hoy (válido hasta 23:59)</span>;
    if (diasRestantes <= 5) return <span className="badge bg-warning shadow-sm">⚠️ Por vencer</span>;
    return <span className="badge bg-success shadow-sm">✅ Vigente</span>;
  };

  // Obtener el icono del plan
  const getPlanIcon = (plan) => {
    const planLower = plan?.toLowerCase() || '';
    if (planLower.includes('premium') || planLower.includes('pro')) return '⭐';
    if (planLower.includes('curso')) return '🎓';
    if (planLower.includes('basic') || planLower.includes('basico')) return '📋';
    if (planLower.includes('enterprise') || planLower.includes('empresa')) return '🏢';
    if (planLower.includes('menor')) return '📄';
    if (planLower.includes('pac')) return '📅';
    if (planLower.includes('admi')) return '👨‍💼';
    return '📦';
  };

  // Obtener el icono del medio de pago
  const getMedioPagoIcon = (medioPago) => {
    const medio = medioPago?.toLowerCase() || '';
    if (medio.includes('tarjeta') || medio.includes('visa') || medio.includes('mastercard')) return '💳';
    if (medio.includes('transferencia') || medio.includes('banco')) return '🏦';
    if (medio.includes('efectivo')) return '💵';
    if (medio.includes('yape') || medio.includes('plin')) return '📱';
    return '💰';
  };

  // Campos del formulario de usuario
  const campos = [
    { name: 'nombre', label: '👤 Nombre completo', placeholder: 'Ej: Juan Pérez García' },
    { name: 'correo', label: '📧 Correo electrónico', type: 'email', placeholder: 'ejemplo@empresa.com' },
    { name: 'celular', label: '📱 Número de celular', placeholder: 'Ej: +51 999 888 777' },
    { name: 'empresa', label: '🏢 Nombre de la empresa', placeholder: 'Ej: Constructora ABC S.A.C.' },
    { 
      name: 'plan', 
      label: '🗂️ Tipo de plan', 
      type: 'select',
      options: [
        { value: '', label: 'Seleccionar plan...' },
        { value: 'MENOR', label: 'MENOR - Contratos Menores' },
        { value: 'PAC', label: 'PAC - Plan Anual de Contrataciones' },
        { value: 'PREMIUM', label: 'PREMIUM - Acceso Completo' },
        { value: 'PLUS_PLUS', label: 'PLAN PLUS+ - Acceso Completo + Generador de Oferta' },
        { value: 'CURSO', label: 'CURSO - Acceso Completo + Cursos' },
         { value: 'MENORES_OLD', label: 'MENORES OLD - Contratos Menores (Versión Antigua)' },
    { value: 'MAYORES_OLD', label: 'MAYORES OLD - Contratos Mayores (Versión Antigua)' },
        { value: 'ADMI', label: 'ADMI - Administrador' },
        { value: 'PRUEBA', label: 'Periodo de prueba' }
      ]
    },
      ...(form.plan === 'CURSO' ? [{
    name: 'curso_tipo',
    label: '🎓 Tipo / Grupo de Curso',
    type: 'select',
    required: true,
    options: [
      { value: '', label: 'Seleccionar grupo de curso...' },
      ...gruposCurso.map(g => ({
        value: g.nombre,
        label: `${g.nombre}${g.descripcion ? ' - ' + g.descripcion : ''}${g.precio ? ' (S/. ' + g.precio + ')' : ''}`
      }))
    ],
    help: 'El precio se asignará automáticamente según el grupo seleccionado'
  }] : []),
  { name: 'ruc', label: '📄 RUC', placeholder: 'Ej: 20123456789' },
  { 
    name: 'valor', 
    label: '💵 Valor mensual (S/.)', 
    type: 'number', 
    placeholder: 'Ej: 299',
    readOnly: form.plan === 'CURSO', // ✅ Solo lectura si es CURSO
    help: form.plan === 'CURSO' ? 'El precio se asigna automáticamente según el curso' : undefined
  },
 
    {
      name: 'fecha_inicio',
      label: '📅 Fecha de inicio',
      type: 'date',
      extra: (
        <button
          type="button"
          className="btn btn-outline-info btn-sm ms-2 shadow-sm"
          onClick={setFechaHoy}
        >
          📅 Hoy
        </button>
      ),
    },
    {
      name: 'mes_suscripcion',
      label: '📆 Duración (meses)',
      type: 'number',
      placeholder: '0',
      min: 0,
      defaultValue: 0,
      help: 'Cantidad de meses de suscripción. Dejar en 0 para usar solo días.'
    },
    {
      name: 'dias_adicionales',
      label: '📅 Días adicionales/totales',
      type: 'number',
      placeholder: '0',
      min: 0,
      defaultValue: 0,
      help: 'Si meses = 0, estos son los días totales. Si meses > 0, son días adicionales.'
    },
    {
      name: 'fecha_fin',
      label: '🏁 Fecha de finalización',
      type: 'date',
      readOnly: true,
      help: 'Se calcula automáticamente. El acceso es válido hasta el final de este día.'
    },
   
    {
  name: 'medio_pago',
  label: '💳 Método de pago',
  type: 'select',
  options: [
    { value: '', label: 'Seleccionar método de pago...' },
    { value: 'TARJETA_CREDITO', label: '💳 Tarjeta de Crédito' },
    { value: 'TARJETA_DEBITO', label: '💳 Tarjeta de Débito' },
    { value: 'TRANSFERENCIA', label: '🏦 Transferencia Bancaria' },
    { value: 'YAPE', label: '📱 Yape' },
    { value: 'PLIN', label: '📱 Plin' },
    { value: 'EFECTIVO', label: '💵 Efectivo' },
  ]
},

{
  name: 'comprobante',
  label: '📋 Comprobante',
  type: 'select',
  options: [
    { value: '', label: 'Seleccionar tipo de comprobante...' },
    { value: 'FACTURA', label: 'FACTURA' },
    { value: 'BOLETA ELECTRONICA', label: 'BOLETA ELECTRONICA' },
    { value: 'SIN COMPROBANTE', label: 'SIN COMPROBANTE' }

  ],
  help: 'Seleccione el tipo de comprobante de pago'
},{
  name: 'flag_emitido',
  label: '📋 Comprobante emitido',
  type: 'checkbox',
  help: 'Marcar si el comprobante ya fue emitido'
},
{
  name: 'flag_depositado',
  label: '💰 Depositado',
  type: 'checkbox',
  help: 'Marcar si el pago ya fue depositado/confirmado'
},
    {
      name: 'comentarios',
      label: '💬 Comentarios',
      type: 'textarea',
      placeholder: 'Observaciones, notas especiales, etc. (opcional)',
      help: 'Información adicional sobre este usuario'
    }
  ];

  // Campos del formulario de pago
  const camposPago = [
    { name: 'celular', label: '📱 Número de celular', placeholder: 'Ej: +51 999 888 777', required: true },
   
    { name: 'correo', label: '📄 correo', placeholder: 'Ej: usuario@gmail.com', required: true },
    { 
      name: 'plan', 
      label: '🗂️ Tipo de plan', 
      type: 'select',
      required: true,
      options: [
        { value: '', label: 'Seleccionar plan...' },
        { value: 'MENOR', label: 'MENOR - Contratos Menores' },
        { value: 'PAC', label: 'PAC - Plan Anual de Contrataciones' },
        { value: 'PREMIUM', label: 'PREMIUM - Acceso Completo' },
        { value: 'PLUS_PLUS', label: 'PLAN PLUS+ - Acceso Completo + Generador de Oferta' },
         { value: 'MENORES_OLD', label: 'MENORES OLD - Contratos Menores (Versión Antigua)' },
    { value: 'MAYORES_OLD', label: 'MAYORES OLD - Contratos Mayores (Versión Antigua)' },
        { value: 'CURSO', label: 'CURSO - Acceso Completo + Cursos' },
        { value: 'ADMI', label: 'ADMI - Administrador' }
      ]
    },
      ...(formPago.plan === 'CURSO' ? [{
    name: 'curso_tipo',
    label: '🎓 Tipo / Grupo de Curso',
    type: 'select',
    required: true,
    options: [
      { value: '', label: 'Seleccionar grupo de curso...' },
      ...gruposCurso.map(g => ({
        value: g.nombre,
        label: `${g.nombre}${g.descripcion ? ' - ' + g.descripcion : ''}${g.precio ? ' (S/. ' + g.precio + ')' : ''}`
      }))
    ],
    help: 'El precio se asignará automáticamente según el grupo seleccionado'
  }] : []),
  { 
    name: 'valor', 
    label: '💵 Valor pagado (S/.)', 
    type: 'number', 
    placeholder: 'Ej: 299', 
    required: true,
    readOnly: formPago.plan === 'CURSO', // ✅ Solo lectura si es CURSO
    help: formPago.plan === 'CURSO' ? 'El precio se asigna automáticamente según el curso' : undefined
  }, 
    { 
      name: 'medio_pago', 
      label: '💳 Medio de pago', 
      type: 'select',
      required: true,
      options: [
        { value: '', label: 'Seleccionar medio de pago...' },
        { value: 'TARJETA_CREDITO', label: '💳 Tarjeta de Crédito' },
        { value: 'TARJETA_DEBITO', label: '💳 Tarjeta de Débito' },
        { value: 'TRANSFERENCIA', label: '🏦 Transferencia Bancaria' },
        { value: 'YAPE', label: '📱 Yape' },
        { value: 'PLIN', label: '📱 Plin' },
        { value: 'EFECTIVO', label: '💵 Efectivo' }
      ]
    },
  {
  name: 'comprobante',
  label: '📋 Comprobante',
  type: 'select',
  required: true,
  options: [
    { value: '', label: 'Seleccionar tipo de comprobante...' },
    { value: 'FACTURA', label: 'FACTURA' },
    { value: 'BOLETA ELECTRONICA', label: 'BOLETA ELECTRONICA' },
    { value: 'SIN COMPROBANTE', label: 'SIN COMPROBANTE' }
  ],
  help: 'Seleccione el tipo de comprobante de pago'
},{
    name: 'flag_emitido',
    label: '📋 Comprobante emitido',
    type: 'checkbox',
    help: 'Marcar si el comprobante ya fue emitido'
  },
  {
    name: 'flag_depositado',
    label: '💰 Depositado',
    type: 'checkbox',
    help: 'Marcar si el pago ya fue depositado/confirmado'
  },
    { name: 'cant_meses', label: '📆 Cantidad de meses', type: 'number', placeholder: 'Ej: 12', required: true }
  ];

  // Renderizar celda editable
  const renderEditableCell = (usuario, campo, tipo = 'text', valor = null) => {
    const isEditing = editingUser === usuario.correo;
    const displayValue = valor || usuario[campo] || '';
    
    if (campo === 'notificado') {
      if (!isEditing) {
        return displayValue ? 
          <span className="badge bg-success">✅ Sí</span> : 
          <span className="badge bg-secondary">❌ No</span>;
      }
      
      return (
        <input
          type="checkbox"
          className="form-check-input"
          checked={editData[campo] || false}
          onChange={(e) => manejarCambioEdicion(campo, e.target.checked)}
          style={{ transform: 'scale(1.2)' }}
        />
      );
    }
    
    if (!isEditing) {
      if (tipo === 'date') {
        if (campo === 'fecha_fin') {
          const fecha = new Date(displayValue);
          return fecha.toLocaleDateString('es-PE') + ' (23:59)';
        }
        return new Date(displayValue).toLocaleDateString('es-PE');
      }
      if (tipo === 'number' && campo === 'valor') {
        return `S/. ${displayValue?.toLocaleString() || '0'}`;
      }
      if (campo === 'comentarios') {
        if (!displayValue) return <span className="text-muted">Sin comentarios</span>;
        const truncated = displayValue.length > 50 ? displayValue.substring(0, 50) + '...' : displayValue;
        return <span title={displayValue} className="text-muted">{truncated}</span>;
      }
      return displayValue || (campo === 'mes_suscripcion' || campo === 'dias_adicionales' ? '0' : '');
    }

    if (campo === 'plan') {
      return (
        <select
          className="form-select form-select-sm"
          value={editData[campo] || ''}
          onChange={(e) => manejarCambioEdicion(campo, e.target.value)}
        >
          <option value="">Seleccionar...</option>
          <option value="MENOR">MENOR</option>
          <option value="PAC">PAC</option>
          <option value="PREMIUM">PREMIUM</option>
          <option value="PLUS_PLUS">PLAN PLUS+</option>
          <option value="CURSO">CURSO</option>
                <option value="MENORES_OLD">MENORES OLD</option>
      <option value="MAYORES_OLD">MAYORES OLD</option>
          <option value="ADMI">ADMI</option>
          <option value="PRUEBA">PRUEBA</option>
        </select>
      );
    }

    if (campo === 'comentarios') {
      return (
        <textarea
          className="form-control form-control-sm"
          value={editData[campo] || ''}
          onChange={(e) => manejarCambioEdicion(campo, e.target.value)}
          rows="2"
          placeholder="Comentarios..."
          style={{ minWidth: '200px', resize: 'vertical' }}
        />
      );
    }

    if (campo === 'fecha_fin' && tipo === 'date') {
      const dateValue = editData[campo] ? 
        (typeof editData[campo] === 'string' && editData[campo].includes('T') ? 
          editData[campo].split('T')[0] : editData[campo]) : '';
      
      return (
        <div className="d-flex align-items-center">
          <input
            type="date"
            className="form-control form-control-sm"
            value={dateValue}
            readOnly
            style={{ 
              minWidth: '120px',
              backgroundColor: '#f8f9fa',
              cursor: 'not-allowed'
            }}
          />
          <small className="text-muted ms-2">(23:59)</small>
        </div>
      );
    }

    if (tipo === 'date') {
      const dateValue = editData[campo] ? 
        (typeof editData[campo] === 'string' && editData[campo].includes('T') ? 
          editData[campo].split('T')[0] : editData[campo]) : '';
      
      return (
        <input
          type="date"
          className="form-control form-control-sm"
          value={dateValue}
          onChange={(e) => manejarCambioEdicion(campo, e.target.value)}
          style={{ minWidth: '120px' }}
        />
      );
    }

    return (
      <input
        type={tipo}
        className="form-control form-control-sm"
        value={editData[campo] !== undefined ? editData[campo] : ''}
        onChange={(e) => manejarCambioEdicion(campo, e.target.value)}
        style={{ minWidth: '120px' }}
      />
    );
  };

  // Renderizar campo del formulario - CORREGIDO
  const renderFormField = (campo, formData, handleChangeFunction) => {
   if (campo.type === 'checkbox') {
  return (
    <div 
      className="form-control form-control-lg border-2 shadow-sm d-flex align-items-center" 
      style={{ 
        borderRadius: '10px',
        backgroundColor: '#f8f9fa',
        minHeight: '58px'
      }}
    >
      <div className="form-check mb-0">
        <input
          type="checkbox"
          name={campo.name}
          checked={formData[campo.name] || false}
          onChange={handleChangeFunction}
          className="form-check-input"
          id={campo.name}
          style={{ 
            transform: 'scale(1.3)',
            marginTop: '0'
          }}
        />
        <label className="form-check-label ms-3 fw-semibold" htmlFor={campo.name}>
          {campo.name === 'flag_depositado' 
            ? 'Sí, el pago fue depositado/confirmado'
            : campo.name === 'flag_emitido'
            ? 'Sí, el comprobante ya fue emitido'
            : 'Sí'
          }
        </label>
      </div>
    </div>
  );
}

    if (campo.type === 'select') {
      return (
        <select
          name={campo.name}
          value={formData[campo.name]}
          onChange={handleChangeFunction}
          className="form-control form-control-lg border-2 shadow-sm"
          required={campo.required}
          style={{ borderRadius: '10px' }}
        >
          {campo.options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      );
    }

    if (campo.type === 'textarea') {
      return (
        <textarea
          name={campo.name}
          value={formData[campo.name]}
          onChange={handleChangeFunction}
          className="form-control form-control-lg border-2 shadow-sm"
          placeholder={campo.placeholder}
          required={campo.required}
          rows="3"
          style={{ borderRadius: '10px', resize: 'vertical' }}
        />
      );
    }

    return (
      <input
        type={campo.type || 'text'}
        name={campo.name}
        value={formData[campo.name]}
        onChange={handleChangeFunction}
        className="form-control form-control-lg border-2 shadow-sm"
        required={campo.required || !campo.readOnly}
        readOnly={campo.readOnly}
        placeholder={campo.placeholder}
        min={campo.min}
        defaultValue={campo.defaultValue}
        style={{ 
          borderRadius: '10px',
          backgroundColor: campo.readOnly ? '#f8f9fa' : 'white'
        }}
      />
    );
  };

  // Función para buscar usuario por correo
const buscarUsuarioPorCorreo = async (correo) => {
  if (!correo || correo.length < 5) {
    setUsuarioBuscado(null);
    return;
  }
  
  try {
    const usuarioEncontrado = usuarios.find(usuario => 
      String(usuario.correo || '').toLowerCase() === correo.toLowerCase()
    );
    
    if (usuarioEncontrado) {
      setUsuarioBuscado({
        nombre: usuarioEncontrado.nombre,
        empresa: usuarioEncontrado.empresa,
        plan: usuarioEncontrado.plan
      });
      
      // Poblar formulario con datos existentes
      setFormPreferencias(prev => ({
        ...prev,
        correo: correo,
        flag_correo: usuarioEncontrado.flag_correo || '',
        palabras_claves: usuarioEncontrado.palabras_claves || '',
        departamentos: usuarioEncontrado.departamentos || '',
        tipo: usuarioEncontrado.tipo || '',
        flag_sunat: usuarioEncontrado.flag_sunat || '',
        correos_cc: usuarioEncontrado.correos_cc || ''
      }));
    } else {
      setUsuarioBuscado(null);
      setFormPreferencias(prev => ({
        correo: correo,
        flag_correo: '',
        palabras_claves: '',
        departamentos: '',
        tipo: '',
        flag_sunat: '',
        correos_cc: ''
      }));
    }
  } catch (error) {
    console.error('Error buscando usuario:', error);
    setUsuarioBuscado(null);
  }
};

// Manejar cambios en formulario de preferencias
const handleChangePreferencias = async (e) => {
  const { name, value } = e.target;
  setFormPreferencias(prev => ({ ...prev, [name]: value }));
  
  if (name === 'correo') {
    await buscarUsuarioPorCorreo(value);
  }
};

// Guardar preferencias
const guardarPreferencias = async (e) => {
  e.preventDefault();
  setLoadingPreferencias(true);
  
  try {
    if (!usuarioBuscado) {
      alert('❌ Error: No se encontró un usuario con ese correo electrónico');
      setLoadingPreferencias(false);
      return;
    }

    const dataToUpdate = {
      flag_correo: formPreferencias.flag_correo,
      palabras_claves: formPreferencias.palabras_claves,
      departamentos: formPreferencias.departamentos,
      tipo: formPreferencias.tipo,
      flag_sunat: formPreferencias.flag_sunat,
      correos_cc: formPreferencias.correos_cc
    };

    await actualizarUsuario(formPreferencias.correo, dataToUpdate);
    
    alert('✅ Preferencias actualizadas correctamente');
    
    setFormPreferencias({
      correo: '',
      flag_correo: '',
      palabras_claves: '',
      departamentos: '',
      tipo: '',
      flag_sunat: '',
      correos_cc: ''
    });
    setUsuarioBuscado(null);
    
    await cargarUsuarios();
    
  } catch (error) {
    console.error('Error:', error);
    alert(`❌ Error al actualizar preferencias: ${error.message}`);
  } finally {
    setLoadingPreferencias(false);
  }
};

// Función para enviar mensaje de WhatsApp de renovación
const enviarWhatsAppRenovacion = (usuario) => {
  const diasRestantes = usuario.dias_restantes;
  let mensajeDias = '';
  
  if (diasRestantes > 0) {
    mensajeDias = `en ${diasRestantes} días`;
  } else if (diasRestantes === 0) {
    mensajeDias = 'hoy';
  } else {
    mensajeDias = `hace ${Math.abs(diasRestantes)} días`;
  }

  const mensaje = `Hola,
Te recordamos que ${mensajeDias} vence tu membresía
Si decides renovar tenemos la siguiente promoción:
Plan básico (Solo contratos menores):
* 3 meses x 40 soles
* 6 meses x 80 soles
Plan plus (Menores y mayores):
* 3 meses x 60 soles
* 6 meses x 120 soles

Yape: 942128139 - Deyvid Torres
Interbank - Inversiones Lirvani SAC
Cta cte: 200-3007312308 
CCI: 003-200-003007312308-32`;

  // Limpiar el número de celular (quitar espacios, guiones, etc.)
  const celularLimpio = String(usuario.celular || '').replace(/\D/g, '');
  
  // Crear URL de WhatsApp
  const whatsappUrl = `https://wa.me/51${celularLimpio}?text=${encodeURIComponent(mensaje)}`;
  
  // Abrir WhatsApp
  window.open(whatsappUrl, '_blank');

  // Marcar como notificado
  marcarComoNotificado(usuario.correo);
};

// Función para marcar como notificado
const marcarComoNotificado = async (correoUsuario) => {
  try {
    await actualizarUsuario(correoUsuario, { notificado: true });
    await cargarUsuarios(); // Recargar la lista
    console.log('Usuario marcado como notificado');
  } catch (error) {
    console.error('Error al marcar como notificado:', error);
  }
};
// ✅ FUNCIONES PARA ANUNCIOS
const guardarGrupoWhatsApp = async () => {
  try {
    await guardarConfiguracionAnuncio(grupoWhatsAppId);
    alert('✅ ID de grupo actualizado correctamente');
  } catch (error) {
    console.error('Error:', error);
    alert('❌ Error al guardar: ' + error.message);
  }
};

const generarMensajeAnuncio = (stats) => {
  let mensaje = '🎯 *REPORTE DIARIO - LICITAHUB*\n\n';
  mensaje += `📅 ${new Date().toLocaleDateString('es-PE', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  })}\n\n`;
  
  mensaje += '📊 *NUEVAS CONVOCATORIAS SEACE*\n';
  mensaje += `Total: *${stats.seace_news.total}* procesos\n\n`;
  
  mensaje += '🗺️ *Por Departamento:*\n';
  const dptoSeace = Object.entries(stats.seace_news.por_departamento)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10);
  dptoSeace.forEach(([dpto, cant]) => {
    mensaje += `• ${dpto}: ${cant}\n`;
  });
  
  mensaje += '\n📋 *Por Objeto:*\n';
  const objetoSeace = Object.entries(stats.seace_news.por_objeto)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10);
  objetoSeace.forEach(([objeto, cant]) => {
    mensaje += `• ${objeto}: ${cant}\n`;
  });
  
  mensaje += '\n\n📄 *CONTRATOS MENORES (HOY)*\n';
  mensaje += `Total: *${stats.contratos_menores.total}* convocatorias\n\n`;
  
  mensaje += '🗺️ *Por Departamento:*\n';
  const dptoMenores = Object.entries(stats.contratos_menores.por_departamento)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10);
  dptoMenores.forEach(([dpto, cant]) => {
    mensaje += `• ${dpto}: ${cant}\n`;
  });
  
  mensaje += '\n📦 *Por Tipo:*\n';
  const tipoMenores = Object.entries(stats.contratos_menores.por_tipo)
    .sort((a, b) => b[1] - a[1]);
  tipoMenores.forEach(([tipo, cant]) => {
    mensaje += `• ${tipo}: ${cant}\n`;
  }); 
  
  mensaje += '\n\n🔗 *Accede a más información en:*\n';
  mensaje += `${URL_PORTAL}/\n\n`;
  mensaje += '_Reporte automático generado por LicitaHub Admin_';
  
  return mensaje;
};
const enviarAnuncioWhatsApp = async () => {
  setLoadingAnuncio(true);
  try {
    const stats = await obtenerEstadisticasAnuncio();
    setEstadisticasAnuncio(stats);
     
    const mensaje = generarMensajeAnuncio(stats);
    
    // Copiar mensaje al portapapeles
    await navigator.clipboard.writeText(mensaje);
    
    // URL usando código de invitación
    const whatsappUrl = `https://chat.whatsapp.com/${grupoWhatsAppId}`;
    
    window.open(whatsappUrl, '_blank');
    
    alert('✅ Mensaje copiado al portapapeles.\n\n📱 Se abrirá el grupo en WhatsApp Web.\n\n⌨️ Solo presiona Ctrl+V (o Cmd+V en Mac) en el chat y luego Enter para enviar.');
  } catch (error) {
    console.error('Error:', error);
    alert('❌ Error al generar anuncio: ' + error.message);
  } finally {
    setLoadingAnuncio(false);
  }
};
// Función para agrupar datos diarios por mes
const procesarIngresosMensuales = (datosDiarios) => {
  const porMes = {};
  datosDiarios.forEach(item => {
    const [day, month, year] = item.fecha.split('/');
    const mesKey = `${String(month).padStart(2, '0')}/${year}`;
    if (!porMes[mesKey]) {
      porMes[mesKey] = { fecha: mesKey, monto: 0, orden: new Date(parseInt(year), parseInt(month) - 1, 1) };
    }
    porMes[mesKey].monto += item.monto;
  });
  return Object.values(porMes).sort((a, b) => a.orden - b.orden);
};

// Función para renderizar el gráfico de ingresos diarios
const renderGraficoIngresos = () => {
  // ✅ FIX: Asegurar que siempre tengamos un array válido
  let datosParaGrafico = [];
  
  // Determinar qué datos usar según el filtro de tipo
  if (window.ingresosDiariosDetallados) {
    switch(filtroTipoIngreso) {
      case 'app':
        datosParaGrafico = window.ingresosDiariosDetallados.app || [];
        break;
      case 'cursos':
        datosParaGrafico = window.ingresosDiariosDetallados.cursos || [];
        break;
      default:
        datosParaGrafico = window.ingresosDiariosDetallados.todos || [];
    }
  } else if (Array.isArray(ingresosDiarios)) {
    // Si ingresosDiarios es un array simple
    datosParaGrafico = ingresosDiarios;
  } else if (ingresosDiarios?.todos) {
    // Si ingresosDiarios tiene la estructura de objeto
    datosParaGrafico = ingresosDiarios.todos || [];
  }
  
  // Aplicar filtros de fecha si existen
  if (ingresosFiltrados && Array.isArray(ingresosFiltrados) && ingresosFiltrados.length > 0) {
    datosParaGrafico = ingresosFiltrados;
  }
  
  // Validar que sea un array (última línea de defensa)
  if (!Array.isArray(datosParaGrafico)) {
    datosParaGrafico = [];
  }
  
  if (datosParaGrafico.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="text-muted">
          <div className="display-1 mb-3">📊</div>
          <h5>No hay datos de ingresos</h5>
          <p>
            {ingresosDiarios.length === 0 
              ? 'Los datos aparecerán cuando haya transacciones registradas'
              : 'No hay datos para el filtro seleccionado'
            }
          </p>
        </div>
      </div>
    );
  }

  const etiquetaTipo = filtroTipoIngreso === 'app' ? '(App Licitaciones)' :
                       filtroTipoIngreso === 'cursos' ? '(Cursos)' : '';

  // Si vista mensual, agrupar por mes
  const datosFinales = vistaGrafico === 'mensual'
    ? procesarIngresosMensuales(datosParaGrafico)
    : datosParaGrafico;

  const maxMonto = Math.max(...datosFinales.map(item => item.monto));
  const esMensual = vistaGrafico === 'mensual';
  const barColor = esMensual
    ? 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)'
    : 'linear-gradient(45deg, #43e97b 0%, #38f9d7 100%)';

  return (
    <div className="p-3">
      {renderFiltrosGrafico()}

      {/* Toggle vista diario/mensual */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="fw-bold mb-0">
          {esMensual ? '📆 Ingresos por Mes' : '📊 Ingresos por Día'} {etiquetaTipo}
        </h6>
        <div className="btn-group btn-group-sm" role="group">
          <button
            type="button"
            className={`btn ${vistaGrafico === 'diario' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setVistaGrafico('diario')}
          >
            📅 Por Día
          </button>
          <button
            type="button"
            className={`btn ${vistaGrafico === 'mensual' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setVistaGrafico('mensual')}
          >
            📆 Por Mes
          </button>
        </div>
      </div>

      <div style={{ height: '300px', overflowX: 'auto' }}>
        <div className="d-flex align-items-end justify-content-center" style={{ height: '250px', minWidth: `${datosFinales.length * (esMensual ? 100 : 80)}px` }}>
          {datosFinales.map((item, index) => {
            const altura = maxMonto > 0 ? (item.monto / maxMonto) * 200 : 10;
            return (
              <div key={index} className="d-flex flex-column align-items-center mx-1" style={{ minWidth: esMensual ? '90px' : '70px' }}>
                <div className="text-center mb-2">
                  <small className="fw-bold" style={{ color: esMensual ? '#764ba2' : '#43e97b' }}>
                    S/. {item.monto.toLocaleString()}
                  </small>
                </div>
                <div
                  className="rounded-top shadow-sm"
                  style={{
                    width: esMensual ? '55px' : '40px',
                    height: `${altura}px`,
                    background: barColor,
                    minHeight: '10px',
                    transition: 'all 0.3s ease'
                  }}
                  title={`${item.fecha}: S/. ${item.monto.toLocaleString()}`}
                ></div>
                <div className="text-center mt-2">
                  <small className="text-muted" style={{ fontSize: '0.7rem', transform: 'rotate(-45deg)', display: 'block', whiteSpace: 'nowrap' }}>
                    {item.fecha}
                  </small>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="mt-3 text-center">
        <div className="row">
          <div className="col-4">
            <div className="text-muted small">Total {filtroMes || filtroFechaInicio || filtroFechaFin ? '(filtrado)' : ''}</div>
            <div className="fw-bold text-success">S/. {datosFinales.reduce((sum, item) => sum + item.monto, 0).toLocaleString()}</div>
          </div>
          <div className="col-4">
            <div className="text-muted small">{esMensual ? 'Promedio/mes' : 'Promedio/día'}</div>
            <div className="fw-bold text-info">
              S/. {datosFinales.length > 0 ? (datosFinales.reduce((sum, item) => sum + item.monto, 0) / datosFinales.length).toFixed(2) : '0.00'}
            </div>
          </div>
          <div className="col-4">
            <div className="text-muted small">{esMensual ? 'Mes más alto' : 'Día más alto'}</div>
            <div className="fw-bold text-warning">S/. {maxMonto.toLocaleString()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
  return (
    <div className="container-fluid py-4" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', minHeight: '100vh' }}>

      {/* Contraseña recién generada: se ve una sola vez */}
      {claveGenerada && (
        <div className="card border-0 shadow-lg mb-4" role="alert"
          style={{ borderLeft: `5px solid ${claveGenerada.error ? '#b42318' : '#0f766e'}` }}>
          <div className="card-body">
            {claveGenerada.error ? (
              <>
                <h5 className="mb-1 text-danger">
                  {claveGenerada.recienCreado ? 'Usuario creado, pero sin contraseña nueva' : 'No se pudo generar la contraseña'}
                </h5>
                <p className="mb-0">
                  {claveGenerada.nombre || claveGenerada.correo}: {claveGenerada.error}
                </p>
                {claveGenerada.recienCreado && (
                  <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>
                    El usuario quedó creado y puede entrar con su RUC. Genera su clave con el botón 🔑 de su fila.
                  </p>
                )}
              </>
            ) : (
              <>
                <h5 className="mb-1">
                  {claveGenerada.recienCreado ? 'Usuario creado. Su contraseña es:' : 'Contraseña nueva para '}
                  {!claveGenerada.recienCreado && (claveGenerada.nombre || claveGenerada.correo)}
                </h5>
                <p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                  {claveGenerada.recienCreado
                    ? `${claveGenerada.nombre || claveGenerada.correo} — envíasela ahora: no se puede volver a consultar.`
                    : 'Envíasela ahora: no se puede volver a consultar, y su clave anterior deja de funcionar.'}
                </p>
                <code style={{ fontSize: '1.6rem', letterSpacing: '0.14em', userSelect: 'all' }}>
                  {claveGenerada.clave}
                </code>
                <p className="mb-0 mt-2" style={{ fontSize: '0.85rem' }}>
                  {claveGenerada.copiado
                    ? <span className="text-success">✅ Mensaje copiado al portapapeles, listo para pegarlo.</span>
                    : <span className="text-warning">El navegador no dejó copiarlo solo: usa el botón de abajo.</span>}
                </p>
              </>
            )}
            <div className="mt-3 d-flex gap-2 flex-wrap">
              {!claveGenerada.error && (
                <button type="button" className="btn btn-sm btn-outline-primary"
                  onClick={async () => {
                    const ok = await copiarCredenciales(
                      claveGenerada.correo, claveGenerada.clave,
                      claveGenerada.recienCreado ? ENCABEZADO_USUARIO_NUEVO : ENCABEZADO_CLAVE_NUEVA
                    );
                    setClaveGenerada(actual => ({ ...actual, copiado: ok }));
                  }}>
                  📋 Copiar mensaje
                </button>
              )}
              <button type="button" className="btn btn-sm btn-outline-secondary"
                onClick={() => setClaveGenerada(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {/* Navegación por pestañas */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow-lg">
            <div className="card-header" style={{ background: 'linear-gradient(45deg, #2c3e50 0%, #34495e 100%)' }}>
              <ul className="nav nav-tabs card-header-tabs border-0 flex-wrap">
                <li className="nav-item">
                  <button
                    className={`nav-link border-0 fw-bold px-3 py-2 ${activeTab === 'usuarios' ? 'active text-dark shadow-sm' : 'text-white'}`}
                    onClick={() => setActiveTab('usuarios')}
                    style={{ borderRadius: '10px 10px 0 0', backgroundColor: activeTab === 'usuarios' ? '#ffffff' : 'transparent', transition: 'all 0.3s ease' }}
                  >
                    👥 Usuarios
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link border-0 fw-bold px-3 py-2 ${activeTab === 'registro' ? 'active text-dark shadow-sm' : 'text-white'}`}
                    onClick={() => setActiveTab('registro')}
                    style={{ borderRadius: '10px 10px 0 0', backgroundColor: activeTab === 'registro' ? '#ffffff' : 'transparent', transition: 'all 0.3s ease' }}
                  >
                    ➕ Registrar
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link border-0 fw-bold px-3 py-2 ${activeTab === 'pagos' ? 'active text-dark shadow-sm' : 'text-white'}`}
                    onClick={() => setActiveTab('pagos')}
                    style={{ borderRadius: '10px 10px 0 0', backgroundColor: activeTab === 'pagos' ? '#ffffff' : 'transparent', transition: 'all 0.3s ease' }}
                  >
                    💳 Pagos
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link border-0 fw-bold px-3 py-2 ${activeTab === 'preferencias' ? 'active text-dark shadow-sm' : 'text-white'}`}
                    onClick={() => setActiveTab('preferencias')}
                    style={{ borderRadius: '10px 10px 0 0', backgroundColor: activeTab === 'preferencias' ? '#ffffff' : 'transparent', transition: 'all 0.3s ease' }}
                  >
                    ⚙️ Preferencias
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link border-0 fw-bold px-3 py-2 ${activeTab === 'tipoPlan' ? 'active text-dark shadow-sm' : 'text-white'}`}
                    onClick={() => setActiveTab('tipoPlan')}
                    style={{ borderRadius: '10px 10px 0 0', backgroundColor: activeTab === 'tipoPlan' ? '#ffffff' : 'transparent', transition: 'all 0.3s ease' }}
                  >
                    💼 Tipos de Plan
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link border-0 fw-bold px-3 py-2 ${activeTab === 'actividad' ? 'active text-dark shadow-sm' : 'text-white'}`}
                    onClick={() => { setActiveTab('actividad'); cargarUsuariosConectadosHoy(); }}
                    style={{ borderRadius: '10px 10px 0 0', backgroundColor: activeTab === 'actividad' ? '#ffffff' : 'transparent', transition: 'all 0.3s ease' }}
                  >
                    🟢 Actividad
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link border-0 fw-bold px-3 py-2 ${activeTab === 'accesos' ? 'active text-dark shadow-sm' : 'text-white'}`}
                    onClick={() => setActiveTab('accesos')}
                    style={{ borderRadius: '10px 10px 0 0', backgroundColor: activeTab === 'accesos' ? '#ffffff' : 'transparent', transition: 'all 0.3s ease' }}
                  >
                    🔐 Accesos
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link border-0 fw-bold px-3 py-2 ${activeTab === 'entidades' ? 'active text-dark shadow-sm' : 'text-white'}`}
                    onClick={() => setActiveTab('entidades')}
                    style={{ borderRadius: '10px 10px 0 0', backgroundColor: activeTab === 'entidades' ? '#ffffff' : 'transparent', transition: 'all 0.3s ease' }}
                  >
                    🏛️ Entidades
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Registrar Pago */}
      {/* Logos de las entidades para «Trabaja para el Estado». Vive en su propio
          componente: el panel ya es largo de sobra. */}
      {activeTab === 'entidades' && (
        <div className="container-fluid px-3 pb-4">
          <AdminEntidades />
        </div>
      )}

      {activeTab === 'pagos' && (
        <>
          {/* Estadísticas de transacciones */}
          <div className="row mb-4">
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 shadow-lg h-100" style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }}>
                <div className="card-body text-white text-center py-4">
                  <div className="display-4 mb-2">💳</div>
                  <h2 className="fw-bold">{estadisticasTransacciones.total_transacciones}</h2>
                  <p className="mb-0 opacity-75">Total Transacciones</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 shadow-lg h-100" style={{ background: 'linear-gradient(45deg, #43e97b 0%, #38f9d7 100%)' }}>
                <div className="card-body text-white text-center py-4">
                  <div className="display-4 mb-2">💰</div>
                  <h2 className="fw-bold">S/. {estadisticasTransacciones.ingresos_totales.toLocaleString()}</h2>
                  <p className="mb-0 opacity-75">Ingresos Totales</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 shadow-lg h-100" style={{ background: 'linear-gradient(45deg, #fa709a 0%, #fee140 100%)' }}>
                <div className="card-body text-white text-center py-4">
                  <div className="display-4 mb-2">📅</div>
                  <h2 className="fw-bold">{estadisticasTransacciones.meses_vendidos}</h2>
                  <p className="mb-0 opacity-75">Meses Vendidos</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 shadow-lg h-100" style={{ background: 'linear-gradient(45deg, #ff6b6b 0%, #feca57 100%)' }}>
                <div className="card-body text-white text-center py-4">
                  <div className="display-4 mb-2">📊</div>
                  <h2 className="fw-bold">{Object.keys(estadisticasTransacciones.por_plan).length}</h2>
                  <p className="mb-0 opacity-75">Planes Vendidos</p>
                </div>
              </div>
            </div>
          </div>

          {/* Gráfico de ingresos diarios */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="card border-0 shadow-lg">
                <div className="card-header py-3" style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }}>
                  <h5 className="mb-0 fw-bold text-white">📈 Evolución de Ingresos Diarios</h5>
                </div>
                <div className="card-body">
                  {renderGraficoIngresos()}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 mb-4">
              {/* Formulario de registro de pago */}
              <div className="card border-0 shadow-lg">
                <div className="card-header text-center py-4" style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }}>
                  <h3 className="mb-0 text-white fw-bold">💳 Registrar Nuevo Pago</h3>
                  <p className="mb-0 text-white opacity-75">Complete la información del pago realizado</p>
                </div>
                <div className="card-body p-4">
                  <form onSubmit={handleSubmitPago}>
                    {camposPago.map((campo) => (
                      <div className="mb-3" key={campo.name}>
                        <label className="form-label fw-bold text-dark">{campo.label}</label>
                        {renderFormField(campo, formPago, handleChangePago)}
                      </div>
                    ))}
                    
                    <div className="text-center mt-4">
                      <button 
                        type="submit" 
                        className="btn btn-lg px-4 py-3 shadow-lg fw-bold"
                        disabled={loadingPago || !conexionOk}
                        style={{ 
                          background: 'linear-gradient(45deg, #43e97b 0%, #38f9d7 100%)',
                          border: 'none',
                          borderRadius: '15px',
                          color: 'white',
                          minWidth: '200px'
                        }}
                      >
                        {loadingPago ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Registrando...
                          </>
                        ) : (
                          <>💾 Registrar Pago</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="col-lg-6 mb-4">
              {/* Lista de transacciones */}
              <div className="card border-0 shadow-lg">
                <div className="card-header d-flex justify-content-between align-items-center py-3" style={{ background: 'linear-gradient(45deg, #2c3e50 0%, #34495e 100%)' }}>
                  <h5 className="mb-0 fw-bold text-white">📋 Últimas Transacciones</h5>
                  <button
                    className="btn btn-outline-light btn-sm shadow-sm"
                    onClick={() => {
                      cargarTransacciones();
                      cargarEstadisticasTransacciones();
                    }}
                  >
                    🔄 Actualizar
                  </button>
                </div>
                <div className="card-body p-0">
                  <div className="p-3">
                    <input
                      type="text"
                      className="form-control shadow-sm"
                      placeholder="Buscar por celular, correo, plan o comprobante..."
                      value={busquedaTransacciones}
                      onChange={(e) => setBusquedaTransacciones(e.target.value)}
                    />
                  </div>
               <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
  {transaccionesFiltradas.length === 0 ? (
    <div className="text-center py-5">
      <div className="text-muted">
        <div className="display-1 mb-3">💳</div>
        <h5>No hay transacciones registradas</h5>
        <p>Las transacciones aparecerán aquí una vez registradas</p>
      </div>
    </div>
  ) : (
    transaccionesFiltradas.map((transaccion, index) => (
      <div key={transaccion.id || index} className={`border-bottom p-3 ${editingTransaction === transaccion.id ? 'bg-light' : ''}`}>
        <div className="row align-items-center">
          <div className="col-md-10">
            <div className="row">
              <div className="col-md-6">
                <div className="d-flex align-items-center mb-2">
                  <span className="badge bg-info me-2">
                    {getPlanIcon(transaccion.plan)} {renderEditableCellTransaction(transaccion, 'plan')}
                  </span>
                  <span className="fw-bold text-success">
                    {renderEditableCellTransaction(transaccion, 'valor', 'number')}
                  </span>
                </div>
                <div className="small text-muted">
                  <div>📱 {renderEditableCellTransaction(transaccion, 'celular')}</div>
                  <div>📄 Correo: {renderEditableCellTransaction(transaccion, 'correo')}</div>
                    {transaccion.plan === 'CURSO' && transaccion.curso_tipo && (
    <div>🎓 Curso: {
      transaccion.curso_tipo === 'MENORES' ? 'Contratos Menores' :
      transaccion.curso_tipo === 'MAYORES' ? 'Contratos Mayores' :
      transaccion.curso_tipo === 'AMBOS' ? 'Ambos Cursos' :
      transaccion.curso_tipo
    }</div>
  )}
                  <div>📋 Comprobante: {renderEditableCellTransaction(transaccion, 'comprobante')}</div>
                  <div className="d-flex align-items-center mt-1">
                    {getMedioPagoIcon(transaccion.medio_pago)}
                    <span className="ms-1">{renderEditableCellTransaction(transaccion, 'medio_pago')}</span>
                    <span className="ms-3">📅 {renderEditableCellTransaction(transaccion, 'cant_meses', 'number')} meses</span>
                  </div>
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="mb-2">
                  <strong>💰 Depositado:</strong> {renderEditableCellTransaction(transaccion, 'flag_depositado')}
                </div>
                <div className="mb-2">
                  <strong>📋 Comprobante Emitido:</strong> {renderEditableCellTransaction(transaccion, 'flag_emitido')}
                </div>
                <div className="small text-muted">
                  {new Date(transaccion.created_at).toLocaleDateString('es-PE', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </div>
              </div>
            </div>
          </div>
          
<div className="col-md-2 text-end">
  <div className="btn-group-vertical btn-group-sm">
    {editingTransaction === transaccion.id ? (
      <>
        <button
          className="btn btn-success btn-sm shadow-sm mb-1"
          onClick={guardarEdicionTransaccion}
          style={{ borderRadius: '8px' }}
        >
          ✅ Guardar
        </button>
        <button
          className="btn btn-secondary btn-sm shadow-sm"
          onClick={cancelarEdicionTransaccion}
          style={{ borderRadius: '8px' }}
        >
          ❌ Cancelar
        </button>
      </>
    ) : (
      <>
        <button
          className="btn btn-outline-primary btn-sm shadow-sm mb-1"
          onClick={() => iniciarEdicionTransaccion(transaccion)}
          title="Editar transacción"
          style={{ borderRadius: '8px' }}
        >
          ✏️ Editar
        </button>
        <button
          className="btn btn-outline-danger btn-sm shadow-sm"
          onClick={() => eliminarTransaccionHandler(
            transaccion.id, 
            transaccion.correo, 
            transaccion.plan
          )}
          title="Eliminar transacción"
          style={{ borderRadius: '8px' }}
        >
          🗑️ Eliminar
        </button>
      </>
    )}
  </div>
</div>
        </div>
      </div>
    ))
  )}
</div>
                </div>
              </div>
            </div>
          </div>

          {/* Estadísticas por plan */}
          {Object.keys(estadisticasTransacciones.por_plan).length > 0 && (
            <div className="row">
              <div className="col-12">
                <div className="card border-0 shadow-lg">
                  <div className="card-header py-3" style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }}>
                    <h5 className="mb-0 fw-bold text-white">📊 Estadísticas por Plan</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {Object.entries(estadisticasTransacciones.por_plan).map(([plan, stats]) => (
                        <div key={plan} className="col-md-3 mb-3">
                          <div className="card border-0 shadow-sm">
                            <div className="card-body text-center">
                              <div className="display-4 mb-2">{getPlanIcon(plan)}</div>
                              <h5 className="fw-bold">{plan}</h5>
                              <p className="mb-1">{stats.cantidad} transacciones</p>
                              <p className="mb-0 text-success fw-bold">S/. {stats.ingresos.toLocaleString()}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

     
{/* Registro de Preferencias */}
{activeTab === 'preferencias' && (
  <div className="row justify-content-center">
    <div className="col-lg-8">
      <div className="card border-0 shadow-lg">
        <div className="card-header text-center py-4" style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }}>
          <h3 className="mb-0 text-white fw-bold">⚙️ Registro de Preferencias</h3>
          <p className="mb-0 text-white opacity-75">Configure las preferencias del usuario</p>
        </div>
        <div className="card-body p-5">
          
          {/* Usuario encontrado */}
          {usuarioBuscado && (
            <div className="alert alert-success mb-4">
              <h6 className="fw-bold">✅ Usuario: {usuarioBuscado.nombre}</h6>
              <p className="mb-0">🏢 {usuarioBuscado.empresa} - 📦 {usuarioBuscado.plan}</p>
            </div>
          )}

          <form onSubmit={guardarPreferencias}>
            
            {/* Correo */}
            <div className="mb-4">
              <label className="form-label fw-bold">📧 Correo del Usuario</label>
              <input
                type="email"
                name="correo"
                value={formPreferencias.correo}
                onChange={handleChangePreferencias}
                className="form-control form-control-lg"
                placeholder="ejemplo@empresa.com"
                required
              />
            </div>

            {usuarioBuscado && (
              <>
                {/* Flag Correo */}
                <div className="mb-4">
                  <label className="form-label fw-bold">📬 Recibir Correos</label>
                  <select
                    name="flag_correo"
                    value={formPreferencias.flag_correo}
                    onChange={handleChangePreferencias}
                    className="form-control form-control-lg"
                  >
                    <option value="">Seleccionar...</option>
                    <option value="SI">✅ SÍ</option>
                    <option value="NO">❌ NO</option>
                  </select>
                </div>

                {/* Palabras Claves */}
                <div className="mb-4">
                  <label className="form-label fw-bold">🔍 Palabras Clave</label>
                  <textarea
                    name="palabras_claves"
                    value={formPreferencias.palabras_claves}
                    onChange={handleChangePreferencias}
                    className="form-control"
                    placeholder="construcción, mantenimiento, ALL"
                    rows="3"
                  />
                </div>

                {/* Departamentos */}
                <div className="mb-4">
                  <label className="form-label fw-bold">🗺️ Departamentos</label>
                  <textarea
                    name="departamentos"
                    value={formPreferencias.departamentos}
                    onChange={handleChangePreferencias}
                    className="form-control"
                    placeholder="LIMA, AREQUIPA, ALL"
                    rows="3"
                  />
                </div>

                {/* Tipo */}
        {/* Tipo - VERSIÓN MODIFICADA CON CHECKBOXES */}
<div className="mb-4">
  <label className="form-label fw-bold">📋 Tipo de Proceso</label>
  <div className="text-muted small mb-2">💡 Selecciona uno o varios tipos. "ALL" selecciona todos automáticamente.</div>
  
  <div className="border rounded p-3" style={{ backgroundColor: '#f8f9fa' }}>
    {/* Opción ALL */}
    <div className="form-check mb-2">
      <input
        type="checkbox"
        id="tipo_all"
        checked={formPreferencias.tipo === 'ALL'}
        onChange={(e) => {
          if (e.target.checked) {
            setFormPreferencias(prev => ({ ...prev, tipo: 'ALL' }));
          } else {
            setFormPreferencias(prev => ({ ...prev, tipo: '' }));
          }
        }}
        className="form-check-input"
      />
      <label className="form-check-label fw-bold" htmlFor="tipo_all">
        🔄 TODOS
      </label>
    </div>
    
    <hr className="my-2" />
    
    {/* Opciones individuales */}
    {[
      { value: 'BIENES', label: '📦 BIENES' },
      { value: 'SERVICIOS', label: '🔧 SERVICIOS' },
      { value: 'OBRAS', label: '🏗️ OBRAS' }
    ].map(opcion => (
      <div key={opcion.value} className="form-check mb-2">
        <input
          type="checkbox"
          id={`tipo_${opcion.value.toLowerCase()}`}
          disabled={formPreferencias.tipo === 'ALL'}
          checked={formPreferencias.tipo === 'ALL' ? false : 
                   (formPreferencias.tipo || '').split(',').map(t => t.trim()).includes(opcion.value)}
          onChange={(e) => {
            const tiposActuales = formPreferencias.tipo === 'ALL' ? [] : 
                                 (formPreferencias.tipo || '').split(',').map(t => t.trim()).filter(t => t);
            
            let nuevosTipos;
            if (e.target.checked) {
              nuevosTipos = [...tiposActuales, opcion.value];
            } else {
              nuevosTipos = tiposActuales.filter(t => t !== opcion.value);
            }
            
            const tipoFinal = nuevosTipos.length === 0 ? '' : nuevosTipos.join(', ');
            setFormPreferencias(prev => ({ ...prev, tipo: tipoFinal }));
          }}
          className="form-check-input"
        />
        <label className="form-check-label" htmlFor={`tipo_${opcion.value.toLowerCase()}`}>
          {opcion.label}
        </label>
      </div>
    ))}
    
    {/* Mostrar selección actual */}
    {formPreferencias.tipo && formPreferencias.tipo !== 'ALL' && (
      <div className="mt-2 p-2 bg-info bg-opacity-10 rounded">
        <small className="text-info">
          <strong>Seleccionados:</strong> {formPreferencias.tipo}
        </small>
      </div>
    )}
  </div>
</div>

                {/* Flag SUNAT */}
                <div className="mb-4">
                  <label className="form-label fw-bold">🏛️ Incluir SUNAT</label>
                  <select
                    name="flag_sunat"
                    value={formPreferencias.flag_sunat}
                    onChange={handleChangePreferencias}
                    className="form-control form-control-lg"
                  >
                    <option value="">Seleccionar...</option>
                    <option value="SI">✅ SÍ</option>
                    <option value="NO">❌ NO</option>
                  </select>
                </div>

{/* AGREGAR ESTE NUEVO CAMPO */}
<div className="mb-4">
  <label className="form-label fw-bold">📧 Correos Alternativos (CC)</label>
  <div className="text-muted small mb-2">
    💡 Ingresa correos adicionales separados por comas. Ejemplo: usuario1@empresa.com, usuario2@empresa.com
  </div>
  <textarea
    name="correos_cc"
    value={formPreferencias.correos_cc}
    onChange={handleChangePreferencias}
    className="form-control"
    placeholder="ejemplo1@empresa.com, ejemplo2@empresa.com"
    rows="3"
  />
  {formPreferencias.correos_cc && (
    <div className="mt-2 p-2 bg-info bg-opacity-10 rounded">
      <small className="text-info">
        <strong>Correos ingresados:</strong> {formPreferencias.correos_cc.split(',').length}
      </small>
    </div>
  )}
</div>
                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-lg px-4 py-3 fw-bold"
                    disabled={loadingPreferencias}
                    style={{ 
                      background: 'linear-gradient(45deg, #43e97b 0%, #38f9d7 100%)',
                      border: 'none',
                      borderRadius: '15px',
                      color: 'white'
                    }}
                  >
                    {loadingPreferencias ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Guardando...
                      </>
                    ) : (
                      <>💾 Guardar Preferencias</>
                    )}
                  </button>
                </div>
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  </div>
)}
      {/* Control de Dashboard */}
      {activeTab === 'dashboard' && (
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card border-0 shadow-lg">
              <div className="card-header text-center py-4" style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }}>
                <h3 className="mb-0 text-white fw-bold">📊 Control del Dashboard General</h3>
                <p className="mb-0 text-white opacity-75">Administra y actualiza los datos del dashboard principal</p>
              </div>
              <div className="card-body p-5">
                <div className="row mb-5">
                  <div className="col-md-4">
                    <div className="card border-0 h-100" style={{ background: 'linear-gradient(45deg, #4facfe 0%, #00f2fe 100%)' }}>
                      <div className="card-body text-white text-center py-4">
                        <div className="display-4 mb-2">📄</div>
                        <h4 className="fw-bold">{statsMenores?.totalConvocatorias?.toLocaleString() || '0'}</h4>
                        <p className="mb-0 opacity-75">Contratos Menores</p>
                        <small className="opacity-75">
                          {formatearUltimaActualizacion(lastUpdateMenores)}
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card border-0 h-100" style={{ background: 'linear-gradient(45deg, #6f42c1 0%, #764ba2 100%)' }}>
                      <div className="card-body text-white text-center py-4">
                        <div className="display-4 mb-2">📊</div>
                        <h4 className="fw-bold">{pacVigenteStats?.totalProcesos?.toLocaleString() || '0'}</h4>
                        <p className="mb-0 opacity-75">PAC Vigente</p>
                        <small className="opacity-75">
                          {formatearUltimaActualizacion(pacVigenteLastUpdate)}
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card border-0 h-100" style={{ background: 'linear-gradient(45deg, #ff6b6b 0%, #feca57 100%)' }}>
                      <div className="card-body text-white text-center py-4">
                        <div className="display-4 mb-2">📅</div>
                        <h4 className="fw-bold">{pacProgramadoStats?.totalProcesos?.toLocaleString() || '0'}</h4>
                        <p className="mb-0 opacity-75">PAC Programado</p>
                        <small className="opacity-75">
                          {formatearUltimaActualizacion(pacProgramadoLastUpdate)}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-12">
                    <div className="card border-0 shadow-sm">
                      <div className="card-body">
                        <div className="row align-items-center">
                          <div className="col-md-8">
                            <h5 className="mb-2 fw-bold">📈 Estado del Dashboard</h5>
                            <div className="d-flex align-items-center gap-3">
                              <span className={`badge bg-${getEstadoDashboard().color} fs-6 px-3 py-2`}>
                                {getEstadoDashboard().icon} {getEstadoDashboard().estado}
                              </span>
                              {lastUpdateMenores && (
                                <span className="text-muted">
                                  Última actualización: {formatearUltimaActualizacion(lastUpdateMenores)}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-4 text-end">
                            <button
                              type="button"
                              className="btn btn-lg px-4 py-3 shadow-lg fw-bold"
                              onClick={actualizarDashboard}
                              disabled={refreshingDashboard || !conexionOk}
                              style={{ 
                                background: refreshingDashboard 
                                  ? 'linear-gradient(45deg, #ffc107 0%, #fd7e14 100%)'
                                  : 'linear-gradient(45deg, #43e97b 0%, #38f9d7 100%)',
                                border: 'none',
                                borderRadius: '15px',
                                color: 'white',
                                minWidth: '200px'
                              }}
                            >
                              {refreshingDashboard ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-3"></span>
                                  Actualizando...
                                </>
                              ) : (
                                <>🔄 Actualizar Dashboard</>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="card border-0 shadow-sm">
                      <div className="card-body">
                        <h6 className="fw-bold mb-3">ℹ️ Información sobre la actualización</h6>
                        <ul className="list-unstyled mb-0">
                          <li className="mb-2">
                            <strong>📄 Contratos Menores:</strong> Actualiza los indicadores y estadísticas de contratos menores a 8 UIT
                          </li>
                          <li className="mb-2">
                            <strong>📊 PAC Vigente:</strong> Refresca los datos de procesos PAC activos para postular
                          </li>
                          <li className="mb-2">
                            <strong>📅 PAC Programado:</strong> Actualiza la información de procesos PAC programados para 2025
                          </li>
                          <li className="mb-2">
                            <strong>⏱️ Tiempo estimado:</strong> La actualización puede tomar entre 30 segundos y 2 minutos
                          </li>
                          <li>
                            <strong>🔄 Frecuencia recomendada:</strong> Una vez por día o cuando sea necesario
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Gestión de Usuarios */}
      {activeTab === 'usuarios' && (
        <>
          <div className="row mb-4">
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 shadow-lg h-100" style={{ background: 'linear-gradient(45deg, #4facfe 0%, #00f2fe 100%)' }}>
                <div className="card-body text-white text-center py-4">
                  <div className="display-4 mb-2">👥</div>
                  <h2 className="fw-bold">{estadisticas.total}</h2>
                  <p className="mb-0 opacity-75">Total Usuarios</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 shadow-lg h-100" style={{ background: 'linear-gradient(45deg, #43e97b 0%, #38f9d7 100%)' }}>
                <div className="card-body text-white text-center py-4">
                  <div className="display-4 mb-2">✅</div>
                  <h2 className="fw-bold">{estadisticas.vigentes}</h2>
                  <p className="mb-0 opacity-75">Vigentes</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 shadow-lg h-100" style={{ background: 'linear-gradient(45deg, #fa709a 0%, #fee140 100%)' }}>
                <div className="card-body text-white text-center py-4">
                  <div className="display-4 mb-2">⚠️</div>
                  <h2 className="fw-bold">{estadisticas.por_vencer}</h2>
                  <p className="mb-0 opacity-75">Por Vencer (5 días)</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="card border-0 shadow-lg h-100" style={{ background: 'linear-gradient(45deg, #ff6b6b 0%, #feca57 100%)' }}>
                <div className="card-body text-white text-center py-4">
                  <div className="display-4 mb-2">🔴</div>
                  <h2 className="fw-bold">{estadisticas.vencidos}</h2>
                  <p className="mb-0 opacity-75">Vencidos</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-12">
              <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }}>
                <div className="card-body text-white text-center py-3">
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <h4 className="mb-0">💰 Ingresos Totales: <strong>S/. {estadisticas.ingresos_totales.toLocaleString()}</strong></h4>
                    </div>
                    <div className="col-md-6">
                      <p className="mb-0 opacity-75">Suma de todos los planes registrados</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
<div className="row mb-4">
  <div className="col-md-6">
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        <div className="input-group input-group-lg">
          <span className="input-group-text bg-primary text-white border-0">🔍</span>
          <input
            type="text"
            className="form-control border-0 shadow-sm"
            placeholder="Buscar por nombre, correo, empresa o teléfono..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            style={{ fontSize: '1.1rem' }}
          />
        </div>
      </div>
    </div>
  </div>
  
  <div className="col-md-3">
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        <select
          className="form-select form-select-lg border-0 shadow-sm"
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          style={{ fontSize: '1.1rem' }}
        >
          <option value="todos">📋 Todos los estados</option>
          <option value="vigentes">✅ Solo vigentes</option>
          <option value="hoy">📅 Vencen hoy</option>
          <option value="proximos">⚠️ Por vencer (5 días)</option>
          <option value="vencidos">🔴 Solo vencidos</option>
        </select>
      </div>
    </div>
  </div>
  
  <div className="col-md-3">
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        <select
          className="form-select form-select-lg border-0 shadow-sm"
          value={filtroPlan}
          onChange={(e) => { setFiltroPlan(e.target.value); setFiltroGrupo('todos'); }}
          style={{ fontSize: '1.1rem' }}
        >
          <option value="todos">📦 Todos los planes</option>
          <option value="MENOR">📄 MENOR</option>
          <option value="PAC">📅 PAC</option>
          <option value="PREMIUM">⭐ PREMIUM</option>
          <option value="PLUS_PLUS">⭐ PLAN PLUS+</option>
          <option value="CURSO">🎓 CURSO</option>
            <option value="MENORES_OLD">📄 MENORES OLD</option>
  <option value="MAYORES_OLD">📊 MAYORES OLD</option>
          <option value="ADMI">👨‍💼 ADMI</option>
          <option value="PRUEBA">🧪 PRUEBA</option>
        </select>
      </div>
    </div>
  </div>

  {filtroPlan === 'CURSO' && (
    <div className="col-md-3">
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <select
            className="form-select form-select-lg border-0 shadow-sm"
            value={filtroGrupo}
            onChange={(e) => setFiltroGrupo(e.target.value)}
            style={{ fontSize: '1.1rem' }}
          >
            <option value="todos">🎓 Todos los grupos</option>
            {gruposCurso.map(g => (
              <option key={g.nombre} value={g.nombre}>
                {g.nombre}{g.descripcion ? ' - ' + g.descripcion : ''}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )}

  {filtro === 'vencidos' && (
    <div className="col-md-3 mt-2 mt-md-0">
      <div className="card border-0 shadow-sm border-danger" style={{ borderLeft: '4px solid #dc3545 !important' }}>
        <div className="card-body">
          <select
            className="form-select form-select-lg border-0 shadow-sm"
            value={sortVencidos}
            onChange={(e) => setSortVencidos(e.target.value)}
            style={{ fontSize: '1.1rem' }}
          >
            <option value="recientes">🔼 Vencidos más recientes</option>
            <option value="antiguos">🔽 Vencidos hace más tiempo</option>
          </select>
        </div>
      </div>
    </div>
  )}
</div>
          <div className="card border-0 shadow-lg">
            <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center py-3">
              <h5 className="mb-0 fw-bold">📋 Lista de Suscriptores ({usuariosFiltrados.length})</h5>
              <div>
                {editingUser && (
                  <div className="btn-group me-3">
                    <button className="btn btn-success btn-sm shadow-sm" onClick={guardarEdicion}>✅ Guardar</button>
                    <button className="btn btn-secondary btn-sm shadow-sm" onClick={cancelarEdicion}>❌ Cancelar</button>
                  </div>
                )}
                <button
                  className="btn btn-warning btn-sm shadow-sm fw-bold me-2"
                  onClick={() => setBulkEditOpen(true)}
                  title="Editar varios usuarios a la vez: agregar meses/días y enviar recordatorios"
                >
                  ⚡ Edición masiva
                </button>
                <button
                  className="btn btn-outline-light btn-sm shadow-sm"
                  onClick={() => {
                    cargarUsuarios();
                    cargarEstadisticas();
                  }}
                  disabled={loading}
                >
                  {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : '🔄 '}
                  Actualizar
                </button>
              </div>
            </div>
            <div className="card-body p-0">
              {loading ? (
                <div className="text-center p-5">
                  <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Cargando...</span>
                  </div>
                  <p className="mt-3 text-muted">Cargando usuarios...</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }} className="text-white">
                      <tr>
                        <th className="border-0 py-3">👤 Usuario</th>
                        <th className="border-0 py-3">🏢 Empresa</th>
                        <th className="border-0 py-3">📱 Contacto</th>
                        <th className="border-0 py-3">📦 Plan</th>
                        <th className="border-0 py-3">📅 Fechas</th>
                        <th className="border-0 py-3">⏰ Días Restantes</th>
                        <th className="border-0 py-3">🚦 Estado</th>
                        <th className="border-0 py-3">💰 Valor</th>
                        <th className="border-0 py-3">💬 Comentarios</th>
                        <th className="border-0 py-3">📬 Notificado</th>
                        <th className="border-0 py-3">🔧 Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usuariosFiltrados.length === 0 ? (
                        <tr>
                          <td colSpan="11" className="text-center py-5">
                            <div className="text-muted">
                              <div className="display-1 mb-3">🔍</div>
                              <h4>
                                {busqueda || filtro !== 'todos' 
                                  ? 'No se encontraron usuarios con los criterios seleccionados'
                                  : 'No hay usuarios registrados'
                                }
                              </h4>
                              <p>Intenta cambiar los filtros de búsqueda</p>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        usuariosFiltrados.map((usuario, index) => (
                          <tr key={usuario.correo || index} className={`border-bottom ${editingUser === usuario.correo ? 'table-warning' : ''}`}>
                            <td className="py-3">
                              <div>
                                <div className="fw-bold text-primary fs-6">
                                  {renderEditableCell(usuario, 'nombre')}
                                </div>
                                <div className="text-muted small">
                                  📧 {renderEditableCell(usuario, 'correo', 'email')}
                                </div>
                                {editingUser !== usuario.correo && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary mt-1 py-0 px-2"
                                    style={{ fontSize: '0.7rem' }}
                                    title="Copiar credenciales del usuario"
                                    onClick={() => {
                                      const mensajeCredenciales = `Hola, te envío tus accesos al app de licitaciones

🌐 Link de app de licitaciones: ${URL_PORTAL}/
🌐 Link clases grabadas: https://aulavirtualnuvia.lovable.app/

📧 Puedes ingresar con tu Gmail o con las siguientes "Credenciales":
- Correo: ${usuario.correo}
- Código único: ${usuario.ruc}`;
                                      navigator.clipboard.writeText(mensajeCredenciales)
                                        .then(() => alert('📋 ¡Credenciales copiadas al portapapeles! Solo pega con Ctrl+V.'))
                                        .catch(() => {
                                          alert('No se pudo copiar automáticamente. Revisa la consola (F12).');
                                          console.log(mensajeCredenciales);
                                        });
                                    }}
                                  >
                                    📋 Copiar credenciales
                                  </button>
                                )}
                              </div>
                            </td>
                            <td className="py-3">
                              <div>
                                <div className="fw-semibold">
                                  {renderEditableCell(usuario, 'empresa')}
                                </div>
                                <div className="text-muted small">
                                  📄 RUC: {renderEditableCell(usuario, 'ruc')}
                                </div>
                              </div>
                            </td>
                            <td className="py-3">
                              <div className="fw-semibold text-info">
                                📱 {renderEditableCell(usuario, 'celular')}
                              </div>
                            </td>
                            
<td className="py-3">
  {editingUser === usuario.correo ? (
    renderEditableCell(usuario, 'plan')
  ) : (
    <>
      <span className="badge bg-info fs-6 px-3 py-2 shadow-sm">
        {getPlanIcon(usuario.plan)} {usuario.plan}
      </span>
      {/* ✅ NUEVO: Mostrar todos los cursos del alumno (puede tener varios separados por coma) */}
      {usuario.plan === 'CURSO' && usuario.curso_tipo && (
        <div className="mt-1 d-flex flex-wrap gap-1">
          {String(usuario.curso_tipo).split(',').map(c => c.trim()).filter(Boolean).map(curso => (
            <small key={curso} className="badge bg-secondary">
              🎓 {
                curso === 'MENORES' ? 'C. Menores' :
                curso === 'MAYORES' ? 'C. Mayores' :
                curso === 'AMBOS' ? 'Ambos' :
                curso
              }
            </small>
          ))}
        </div>
      )}
    </>
  )}
</td>
                            <td className="py-3">
                              <div>
                                <div className="small">
                                  📅 <strong>Inicio:</strong> {renderEditableCell(usuario, 'fecha_inicio', 'date')}
                                </div>
                                <div className="small">
                                  🗓️ <strong>Meses:</strong> {renderEditableCell(usuario, 'mes_suscripcion', 'number')}
                                </div>
                                {(usuario.dias_adicionales || editingUser === usuario.correo) && (
                                  <div className="small">
                                    📅 <strong>Días+:</strong> {renderEditableCell(usuario, 'dias_adicionales', 'number')}
                                  </div>
                                )}
                                <div className="small">
                                  🏁 <strong>Fin:</strong> {renderEditableCell(usuario, 'fecha_fin', 'date')}
                                </div>
                              </div>
                            </td>
                            <td className="py-3">
                              <div className={`fw-bold fs-6 ${getEstadoColor(usuario.dias_restantes)}`}>
                                {usuario.dias_restantes > 0 
                                  ? `⏰ ${usuario.dias_restantes} días`
                                  : usuario.dias_restantes === 0
                                  ? `⏰ Vence hoy`
                                  : `⏱️ Venció hace ${Math.abs(usuario.dias_restantes)} días`
                                }
                              </div>
                            </td>
                            <td className="py-3">{getEstadoBadge(usuario.dias_restantes)}</td>
                            <td className="py-3">
                              <div className="fw-bold text-success fs-6">
                                {renderEditableCell(usuario, 'valor', 'number')}
                              </div>
                              {editingUser !== usuario.correo && (
                                <div className="text-muted small">mensual</div>
                              )}
                            </td>
                            <td className="py-3" style={{ maxWidth: '200px' }}>
                              {renderEditableCell(usuario, 'comentarios')}
                            </td>
                            <td className="py-3 text-center">
                              {renderEditableCell(usuario, 'notificado')}
                            </td>
                            <td className="py-3">
                              <div className="btn-group-vertical btn-group-sm">
                                {editingUser === usuario.correo ? (
                                  <>
                                    <button
                                      className="btn btn-success btn-sm shadow-sm mb-1"
                                      onClick={guardarEdicion}
                                      style={{ borderRadius: '8px' }}
                                    >
                                      ✅ Guardar
                                    </button>
                                    <button
                                      className="btn btn-secondary btn-sm shadow-sm"
                                      onClick={cancelarEdicion}
                                      style={{ borderRadius: '8px' }}
                                    >
                                      ❌ Cancelar
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      className="btn btn-outline-success btn-sm shadow-sm mb-1"
                                      onClick={() => enviarWhatsAppRenovacion(usuario)}
                                      title="Enviar mensaje de renovación por WhatsApp"
                                      style={{ borderRadius: '8px' }}
                                    >
                                      📱 WhatsApp
                                    </button>
                                    <button
                                      className="btn btn-outline-primary btn-sm shadow-sm mb-1"
                                      onClick={() => iniciarEdicion(usuario)}
                                      title="Editar usuario"
                                      style={{ borderRadius: '8px' }}
                                    >
                                      ✏️ Editar
                                    </button>
                                    <button
                                      className="btn btn-outline-secondary btn-sm shadow-sm mb-1"
                                      onClick={() => generarClaveHandler(usuario)}
                                      title="Generar una contraseña nueva para este usuario"
                                      style={{ borderRadius: '8px' }}
                                    >
                                      🔑 Clave
                                    </button>
                                    <button
                                      className="btn btn-outline-danger btn-sm shadow-sm"
                                      onClick={() => eliminarUsuarioHandler(usuario.correo, usuario.nombre)}
                                      title="Eliminar usuario"
                                      style={{ borderRadius: '8px' }}
                                    >
                                      🗑️ Eliminar
                                    </button>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* Formulario de registro */}
      {activeTab === 'registro' && (
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center mb-3">
              <button
                type="button"
                className="btn btn-lg fw-bold shadow-sm px-4 py-2"
                onClick={() => { setShowModalGrupo(true); setMostrarResultadosGrupo(false); setResultadosGrupo([]); }}
                style={{ background: 'linear-gradient(45deg, #f093fb 0%, #f5576c 100%)', border: 'none', borderRadius: '50px', color: 'white' }}
              >
                👥 Crear Usuarios en Grupo
              </button>
              <p className="text-muted small mt-1">Registra varios usuarios a la vez con configuración compartida</p>
            </div>
            <div className="card border-0 shadow-lg">
              <div className="card-header text-center py-4" style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }}>
                <h3 className="mb-0 text-white fw-bold">📋 Registro de Nuevo Usuario</h3>
                <p className="mb-0 text-white opacity-75">Complete todos los campos para registrar un nuevo suscriptor</p>
              </div>
              <div className="card-body p-5">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {campos.map((campo) => (
                      <div className={`${campo.type === 'textarea' ? 'col-12' : 'col-md-6'} mb-4`} key={campo.name}>
                        <label className="form-label fw-bold text-dark fs-6">{campo.label}</label>
                        {campo.help && (
                          <div className="text-muted small mb-2">💡 {campo.help}</div>
                        )}
                        <div className="d-flex align-items-center">
                          {renderFormField(campo, form, handleChange)}
                          {campo.extra}
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="text-center mt-4">
                    <button 
                      type="submit" 
                      className="btn btn-lg px-5 py-3 shadow-lg fw-bold"
                      disabled={loading || !conexionOk}
                      style={{ 
                        background: 'linear-gradient(45deg, #43e97b 0%, #38f9d7 100%)',
                        border: 'none',
                        borderRadius: '50px',
                        color: 'white'
                      }}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-3"></span>
                          Guardando usuario...
                        </>
                      ) : (
                        <>💾 Guardar Usuario</>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )
      
      
      }
      {/* ✅ NUEVA SECCIÓN: Anuncios */}
{activeTab === 'anuncios' && (
  <div className="row justify-content-center">
    <div className="col-lg-10">
      <div className="card border-0 shadow-lg">
        <div className="card-header text-center py-4" style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }}>
          <h3 className="mb-0 text-white fw-bold">📢 Gestión de Anuncios</h3>
          <p className="mb-0 text-white opacity-75">Envía reportes automáticos a grupos de WhatsApp</p>
        </div>
        <div className="card-body p-5">
          
          {/* Configuración del grupo */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <h5 className="fw-bold mb-3">⚙️ Configuración</h5>
              <div className="row">
                <div className="col-md-9">
                  <label className="form-label fw-bold">ID del Grupo de WhatsApp</label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    value={grupoWhatsAppId}
                    onChange={(e) => setGrupoWhatsAppId(e.target.value)}
                    placeholder="Ej: D2Dq4IKd4IhDca8zuAIH3a"
                  />
                  <small className="text-muted">
                    💡 Para obtener el ID del grupo, abre WhatsApp Web, ingresa al grupo y copia el ID de la URL
                  </small>
                </div>
                <div className="col-md-3 d-flex align-items-end">
                  <button
                    className="btn btn-primary btn-lg w-100"
                    onClick={guardarGrupoWhatsApp}
                  >
                    💾 Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Botón de anuncio */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body text-center p-5">
              <div className="display-1 mb-3">📱</div>
              <h4 className="fw-bold mb-3">LicitaHub Privado</h4>
              <p className="text-muted mb-4">
                Envía un reporte automático con las estadísticas del día
              </p>
              <button
                className="btn btn-lg px-5 py-3 shadow-lg fw-bold"
                onClick={enviarAnuncioWhatsApp}
                disabled={loadingAnuncio || !grupoWhatsAppId}
                style={{ 
                  background: loadingAnuncio 
                    ? 'linear-gradient(45deg, #ffc107 0%, #fd7e14 100%)'
                    : 'linear-gradient(45deg, #25D366 0%, #128C7E 100%)',
                  border: 'none',
                  borderRadius: '15px',
                  color: 'white',
                  minWidth: '250px'
                }}
              >
                {loadingAnuncio ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Generando...
                  </>
                ) : (
                  <>📢 Enviar Anuncio WhatsApp</>
                )}
              </button>
            </div>
          </div>

          {/* Preview de estadísticas */}
          {estadisticasAnuncio && (
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-light">
                <h5 className="mb-0 fw-bold">📊 Vista Previa del Reporte</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h6 className="fw-bold text-primary">📊 SEACE News</h6>
                    <p className="mb-2"><strong>Total:</strong> {estadisticasAnuncio.seace_news.total} procesos</p>
                    <p className="mb-2"><strong>Top 5 Departamentos:</strong></p>
                    <ul className="list-unstyled ms-3">
                      {Object.entries(estadisticasAnuncio.seace_news.por_departamento)
                        .sort((a, b) => b[1] - a[1])
                        .slice(0, 5)
                        .map(([dpto, cant]) => (
                          <li key={dpto}>• {dpto}: {cant}</li>
                        ))}
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <h6 className="fw-bold text-success">📄 Contratos Menores (Hoy)</h6>
                    <p className="mb-2"><strong>Total:</strong> {estadisticasAnuncio.contratos_menores.total} convocatorias</p>
                    <p className="mb-2"><strong>Top 5 Departamentos:</strong></p>
                    <ul className="list-unstyled ms-3">
                      {Object.entries(estadisticasAnuncio.contratos_menores.por_departamento)
                        .sort((a, b) => b[1] - a[1])
                        .slice(0, 5)
                        .map(([dpto, cant]) => (
                          <li key={dpto}>• {dpto}: {cant}</li>
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Información adicional */}
          <div className="alert alert-info mt-4">
            <h6 className="fw-bold">ℹ️ Información importante:</h6>
            <ul className="mb-0">
              <li>El mensaje se generará automáticamente con los datos más recientes</li>
              <li>Se abrirá WhatsApp Web en una nueva pestaña</li>
              <li>Deberás hacer clic en "Enviar" manualmente en WhatsApp</li>
              <li>Asegúrate de estar conectado a WhatsApp Web antes de enviar</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

      {/* Tipos de Plan */}
      {activeTab === 'tipoPlan' && (
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card border-0 shadow-lg mb-4">
              <div className="card-header py-3" style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)' }}>
                <h5 className="mb-0 fw-bold text-white">💼 Grupos / Tipos de Plan para Cursos</h5>
                <small style={{ color: 'rgba(255,255,255,0.65)' }}>
                  Define los grupos de alumnos para tus cursos por Zoom (Ej: Grupo 1 - Contratos Menores)
                </small>
              </div>
              <div className="card-body p-4">

                {/* Formulario para crear nuevo grupo */}
                <div className="card border-0 bg-light mb-4">
                  <div className="card-body">
                    <h6 className="fw-bold mb-3">➕ Crear nuevo grupo</h6>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label className="form-label fw-bold">Nombre del grupo <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Ej: GRUPO_1_MENORES"
                          value={formGrupo.nombre}
                          onChange={e => setFormGrupo({ ...formGrupo, nombre: e.target.value })}
                        />
                        <small className="text-muted">Se convertirá a mayúsculas automáticamente</small>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-bold">Descripción</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Ej: Contratos Menores - Zoom Martes 7pm"
                          value={formGrupo.descripcion}
                          onChange={e => setFormGrupo({ ...formGrupo, descripcion: e.target.value })}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-bold">Perfil de acceso <span className="text-danger">*</span></label>
                        <select
                          className="form-select"
                          value={formGrupo.perfil}
                          onChange={e => setFormGrupo({ ...formGrupo, perfil: e.target.value })}
                        >
                          {PERFILES_GRUPO_CURSO.map(perfil => (
                            <option key={perfil.code} value={perfil.code}>{perfil.label}</option>
                          ))}
                        </select>
                        <small className="text-muted">Qué secciones del portal verá el alumno</small>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label fw-bold">Precio (S/.)</label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Ej: 80"
                          min="0"
                          value={formGrupo.precio}
                          onChange={e => setFormGrupo({ ...formGrupo, precio: e.target.value })}
                        />
                      </div>
                      <div className="col-md-2 d-flex align-items-end">
                        <button
                          className="btn fw-bold w-100 text-white"
                          style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', border: 'none' }}
                          onClick={agregarGrupoCurso}
                          disabled={guardandoGrupos}
                        >
                          {guardandoGrupos ? 'Guardando…' : '➕ Agregar'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Lista de grupos existentes */}
                <h6 className="fw-bold mb-3">📋 Grupos creados ({gruposCurso.length})</h6>
                {gruposCurso.length === 0 ? (
                  <div className="text-center py-4 text-muted">
                    <div className="display-4">📂</div>
                    <p>No hay grupos creados aún</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover align-middle">
                      <thead className="table-dark">
                        <tr>
                          <th>Nombre</th>
                          <th>Descripción</th>
                          <th style={{ minWidth: '230px' }}>Perfil de acceso</th>
                          <th>Precio (S/.)</th>
                          <th className="text-center">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {gruposCurso.map(grupo => (
                          <tr key={grupo.id}>
                            <td>
                              <span className="badge fw-bold fs-6" style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', color: '#e0e0e0' }}>{grupo.nombre}</span>
                            </td>
                            <td>{grupo.descripcion || <span className="text-muted">—</span>}</td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                value={grupo.perfil || 'CURSO'}
                                disabled={guardandoGrupos}
                                onChange={e => cambiarPerfilGrupo(grupo.id, e.target.value)}
                              >
                                {PERFILES_GRUPO_CURSO.map(perfil => (
                                  <option key={perfil.code} value={perfil.code}>{perfil.label}</option>
                                ))}
                              </select>
                            </td>
                            <td>
                              {grupo.precio > 0
                                ? <span className="fw-bold text-success">S/. {grupo.precio}</span>
                                : <span className="text-muted">—</span>
                              }
                            </td>
                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => eliminarGrupoCurso(grupo.id)}
                                disabled={guardandoGrupos}
                              >
                                🗑️ Eliminar
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="alert alert-info mt-3">
                  <strong>💡 ¿Cómo funciona?</strong><br />
                  Los grupos creados aquí aparecerán como opciones en el campo <strong>"Tipo / Grupo de Curso"</strong> al registrar
                  o crear un usuario con plan <strong>CURSO</strong>. El precio asignado al grupo se aplicará automáticamente.
                  <hr className="my-2" />
                  El <strong>perfil de acceso</strong> decide qué ve el alumno en el portal:
                  <strong> Básico</strong> = Contratos Menores, calendario, tutoriales y catálogo;
                  <strong> Plus</strong> = lo anterior + SEACE, sin el Generador de Oferta;
                  <strong> Plus+</strong> = todo, con Generador incluido.
                  Si un alumno está en dos grupos, suma los accesos de ambos.
                  El Generador de Oferta también se puede conceder por separado, grupo por grupo,
                  en la pestaña <strong>🔐 Accesos</strong>.
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Accesos configurables */}
      {activeTab === 'accesos' && (
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="card border-0 shadow-lg mb-4">
              <div className="card-header py-3" style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)' }}>
                <h5 className="mb-0 fw-bold text-white">🔐 Accesos por Plan</h5>
                <small style={{ color: 'rgba(255,255,255,0.65)' }}>
                  Define qué planes tienen acceso a secciones especiales del portal
                </small>
              </div>
              <div className="card-body p-4">

                <div className="card border-0 bg-light mb-3">
                  <div className="card-body">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <span className="fs-4">📄</span>
                      <h6 className="fw-bold mb-0">Generador de Oferta</h6>
                    </div>
                    <p className="text-muted small mb-3">
                      Marca los planes que podrán ver y usar el <strong>Generador de Oferta</strong> dentro de SEACE.
                      El plan <strong>Administrador</strong> siempre tiene acceso.
                    </p>

                    <div className="row g-2">
                      {PLANES_ASIGNABLES.map(plan => {
                        // Plan CURSO: casilla maestra que despliega los grupos creados
                        if (plan.code === 'CURSO') {
                          return (
                            <div className="col-12" key={plan.code}>
                              <div
                                className="rounded border p-2"
                                style={{
                                  background: cursoExpandido ? '#e7f1ff' : '#ffffff',
                                  borderColor: cursoExpandido ? '#0d6efd' : '#dee2e6',
                                  transition: 'all 0.2s ease'
                                }}
                              >
                                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: 'pointer' }}>
                                  <input
                                    type="checkbox"
                                    className="form-check-input mt-0"
                                    checked={cursoExpandido}
                                    onChange={toggleCursoExpandido}
                                  />
                                  <span className="fw-semibold">{plan.label}</span>
                                  <span className="badge bg-secondary ms-auto">{plan.code}</span>
                                </label>

                                {cursoExpandido && (
                                  <div className="mt-2 ps-4">
                                    {gruposCurso.length === 0 ? (
                                      <div className="alert alert-warning py-2 px-3 mb-0 small">
                                        No hay grupos creados aún. Ve a la pestaña <strong>💼 Tipos de Plan</strong> para crearlos.
                                      </div>
                                    ) : (
                                      <>
                                        <label className="d-flex align-items-center gap-2 mb-2" style={{ cursor: 'pointer' }}>
                                          <input
                                            type="checkbox"
                                            className="form-check-input mt-0"
                                            checked={generadorPlanes.includes('CURSO')}
                                            onChange={toggleCursoTodos}
                                          />
                                          <span className="fw-semibold text-primary">Todos los grupos de curso</span>
                                        </label>
                                        <div className="row g-2">
                                          {gruposCurso.map(grupo => {
                                            const code = `CURSO:${String(grupo.nombre).trim().toUpperCase()}`;
                                            const todos = generadorPlanes.includes('CURSO');
                                            const grupoActivo = todos || generadorPlanes.includes(code);
                                            return (
                                              <div className="col-md-6" key={grupo.id}>
                                                <label
                                                  className="d-flex align-items-center gap-2 p-2 rounded border mb-0"
                                                  style={{
                                                    cursor: todos ? 'not-allowed' : 'pointer',
                                                    background: grupoActivo ? '#eafaf1' : '#ffffff',
                                                    borderColor: grupoActivo ? '#198754' : '#dee2e6',
                                                    opacity: todos ? 0.7 : 1,
                                                    transition: 'all 0.2s ease'
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input mt-0"
                                                    checked={grupoActivo}
                                                    disabled={todos}
                                                    onChange={() => toggleCursoGrupo(grupo.nombre)}
                                                  />
                                                  <span className="fw-semibold">{grupo.nombre}</span>
                                                  {grupo.descripcion && (
                                                    <span className="text-muted small ms-auto text-end">{grupo.descripcion}</span>
                                                  )}
                                                </label>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        }

                        const activo = generadorPlanes.includes(plan.code);
                        return (
                          <div className="col-md-6" key={plan.code}>
                            <label
                              className="d-flex align-items-center gap-2 p-2 rounded border mb-0"
                              style={{
                                cursor: 'pointer',
                                background: activo ? '#e7f1ff' : '#ffffff',
                                borderColor: activo ? '#0d6efd' : '#dee2e6',
                                transition: 'all 0.2s ease'
                              }}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input mt-0"
                                checked={activo}
                                onChange={() => togglePlanGenerador(plan.code)}
                              />
                              <span className="fw-semibold">{plan.label}</span>
                              <span className="badge bg-secondary ms-auto">{plan.code}</span>
                            </label>
                          </div>
                        );
                      })}
                    </div>

                    <div className="d-flex align-items-center justify-content-between mt-3 flex-wrap gap-2">
                      <span className="text-muted small">
                        {generadorPlanes.length === 0
                          ? 'Ningún plan (además de ADMI) tiene acceso'
                          : `${generadorPlanes.length} acceso${generadorPlanes.length !== 1 ? 's' : ''} configurado${generadorPlanes.length !== 1 ? 's' : ''}`}
                      </span>
                      <button
                        className="btn fw-bold text-white"
                        style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', border: 'none' }}
                        onClick={guardarAccesosGeneradorHandler}
                        disabled={guardandoAccesos}
                      >
                        {guardandoAccesos
                          ? <><span className="spinner-border spinner-border-sm me-2"></span>Guardando...</>
                          : '💾 Guardar accesos'}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="alert alert-info mb-0">
                  <strong>💡 ¿Cómo funciona?</strong><br />
                  Al guardar, los usuarios de los planes marcados verán el <strong>Generador de Oferta</strong> en el menú
                  de SEACE la próxima vez que carguen el portal. Los usuarios de planes no marcados no podrán acceder,
                  ni siquiera ingresando la dirección directamente.
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Actividad de usuarios */}
      {activeTab === 'actividad' && (
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card border-0 shadow-lg">
              <div className="card-header py-3" style={{ background: 'linear-gradient(45deg, #11998e 0%, #38ef7d 100%)' }}>
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div>
                    <h5 className="mb-0 fw-bold text-white">🟢 Actividad de usuarios</h5>
                    <small className="text-white opacity-75">
                      {new Date(fechaActividad + 'T12:00:00').toLocaleDateString('es-PE', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                      {' — '}{usuariosConectadosHoy.length} conexión{usuariosConectadosHoy.length !== 1 ? 'es' : ''}
                    </small>
                  </div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <button
                      className="btn btn-sm fw-bold"
                      style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.5)' }}
                      onClick={() => {
                        const hoy = new Date().toISOString().split('T')[0];
                        setFechaActividad(hoy);
                        cargarUsuariosConectadosHoy(hoy);
                      }}
                    >
                      Hoy
                    </button>
                    <button
                      className="btn btn-sm fw-bold"
                      style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.5)' }}
                      onClick={() => {
                        const ayer = new Date();
                        ayer.setDate(ayer.getDate() - 1);
                        const ayerStr = ayer.toISOString().split('T')[0];
                        setFechaActividad(ayerStr);
                        cargarUsuariosConectadosHoy(ayerStr);
                      }}
                    >
                      Ayer
                    </button>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      style={{ width: 'auto', background: 'rgba(255,255,255,0.9)', border: 'none' }}
                      value={fechaActividad}
                      max={new Date().toISOString().split('T')[0]}
                      onChange={(e) => {
                        setFechaActividad(e.target.value);
                        cargarUsuariosConectadosHoy(e.target.value);
                      }}
                    />
                    <button className="btn btn-sm btn-light fw-bold" onClick={() => cargarUsuariosConectadosHoy()} disabled={loadingActividad}>
                      {loadingActividad ? '⏳' : '🔄'}
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                {loadingActividad ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-success" role="status"></div>
                    <p className="mt-2 text-muted">Cargando actividad...</p>
                  </div>
                ) : usuariosConectadosHoy.length === 0 ? (
                  <div className="text-center py-5 text-muted">
                    <div style={{ fontSize: '3rem' }}>😴</div>
                    <p className="mt-2">Ningún usuario se ha conectado hoy todavía.</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Usuario</th>
                          <th>Empresa</th>
                          <th>Plan</th>
                          <th>Hora de conexión</th>
                        </tr>
                      </thead>
                      <tbody>
                        {usuariosConectadosHoy.map((u, index) => {
                          const fecha = new Date(u.ultimo_acceso);
                          const hora = fecha.toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
                          return (
                            <tr key={u.correo}>
                              <td className="text-muted">{index + 1}</td>
                              <td>
                                <div className="fw-bold">{u.nombre || u.correo}</div>
                                <small className="text-muted">{u.correo}</small>
                              </td>
                              <td>{u.empresa || '—'}</td>
                              <td>
                                <span className="badge" style={{ background: u.plan === 'ADMI' ? '#667eea' : u.plan === 'AMBOS' ? '#11998e' : '#fa709a', color: 'white' }}>
                                  {u.plan}
                                </span>
                              </td>
                              <td>
                                <span className="text-success fw-bold">{hora}</span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Modal Edición Masiva de Suscriptores */}
      {bulkEditOpen && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060, position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', overflow: 'auto' }}>
          <div className="modal-dialog modal-xl modal-dialog-scrollable" style={{ margin: '1.5rem auto', maxWidth: '95%' }}>
            <div className="modal-content">
              <div className="modal-header py-3" style={{ background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)' }}>
                <h4 className="modal-title text-white fw-bold">⚡ Edición masiva de suscriptores</h4>
                <button type="button" className="btn-close btn-close-white" onClick={() => setBulkEditOpen(false)}></button>
              </div>
              <div className="modal-body p-3">
                {/* Barra de acciones */}
                <div className="card border-0 shadow-sm mb-3">
                  <div className="card-body">
                    <div className="row g-2 align-items-end">
                      <div className="col-md-4">
                        <label className="form-label fw-bold mb-1">🔍 Buscar</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Nombre, correo, empresa o teléfono..."
                          value={bulkBusqueda}
                          onChange={(e) => setBulkBusqueda(e.target.value)}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-bold mb-1">📦 Plan</label>
                        <select
                          className="form-select"
                          value={bulkFiltroPlan}
                          onChange={(e) => { setBulkFiltroPlan(e.target.value); setBulkFiltroGrupo('todos'); }}
                        >
                          <option value="todos">📦 Todos los planes</option>
                          <option value="MENOR">📄 MENOR</option>
                          <option value="PAC">📅 PAC</option>
                          <option value="PREMIUM">⭐ PREMIUM</option>
                          <option value="PLUS_PLUS">⭐ PLAN PLUS+</option>
                          <option value="CURSO">🎓 CURSO</option>
                          <option value="MENORES_OLD">📄 MENORES OLD</option>
                          <option value="MAYORES_OLD">📊 MAYORES OLD</option>
                          <option value="ADMI">👨‍💼 ADMI</option>
                          <option value="PRUEBA">🧪 PRUEBA</option>
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-bold mb-1">🚦 Estado</label>
                        <select
                          className="form-select"
                          value={bulkFiltroEstado}
                          onChange={(e) => setBulkFiltroEstado(e.target.value)}
                        >
                          <option value="todos">📋 Todos los estados</option>
                          <option value="vigentes">✅ Solo vigentes</option>
                          <option value="hoy">📅 Vencen hoy</option>
                          <option value="proximos">⚠️ Por vencer (5 días)</option>
                          <option value="vencidos">🔴 Solo vencidos</option>
                        </select>
                      </div>
                      {bulkFiltroPlan === 'CURSO' && (
                        <div className="col-md-4">
                          <label className="form-label fw-bold mb-1">🎓 Tipo de curso</label>
                          <select
                            className="form-select"
                            value={bulkFiltroGrupo}
                            onChange={(e) => setBulkFiltroGrupo(e.target.value)}
                          >
                            <option value="todos">🎓 Todos los tipos</option>
                            {gruposCurso.map(g => (
                              <option key={g.nombre} value={g.nombre}>
                                {g.nombre}{g.descripcion ? ' - ' + g.descripcion : ''}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>
                    <div className="row g-2 align-items-end mt-1">
                      <div className="col-md-2">
                        <label className="form-label fw-bold mb-1">🗓️ + Meses</label>
                        <input
                          type="number"
                          min="0"
                          className="form-control"
                          value={bulkMeses}
                          onChange={(e) => setBulkMeses(e.target.value)}
                          placeholder="0"
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label fw-bold mb-1">📅 + Días</label>
                        <input
                          type="number"
                          min="0"
                          className="form-control"
                          value={bulkDias}
                          onChange={(e) => setBulkDias(e.target.value)}
                          placeholder="0"
                        />
                      </div>
                      <div className="col-md-8 d-flex gap-2">
                        <button className="btn btn-primary fw-bold flex-fill" onClick={aplicarTiempoASeleccionados}>
                          ➕ Aplicar a seleccionados
                        </button>
                        <button className="btn btn-outline-secondary" onClick={limpiarCambiosMasivos} title="Limpiar todos los cambios pendientes">
                          🧹 Limpiar
                        </button>
                      </div>
                    </div>
                    <div className="mt-2 small text-muted">
                      Marca los usuarios, escribe cuántos meses/días agregar y pulsa <strong>Aplicar a seleccionados</strong>.
                      También puedes escribir directamente en cada fila. Al final pulsa <strong>Guardar cambios</strong>.
                      Los planes <strong>vigentes</strong> se extienden desde su fecha actual; los <strong>vencidos</strong> se renuevan desde hoy.
                    </div>
                  </div>
                </div>

                {/* Tabla de usuarios */}
                <div className="table-responsive" style={{ maxHeight: '55vh', overflow: 'auto' }}>
                  <table className="table table-sm table-hover align-middle mb-0">
                    <thead className="table-dark" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                      <tr>
                        <th style={{ width: '40px' }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={bulkUsuarios.length > 0 && bulkUsuarios.every(u => bulkSelected[u.correo])}
                            onChange={() => toggleBulkSeleccionTodos(bulkUsuarios)}
                            title="Seleccionar todos"
                          />
                        </th>
                        <th>👤 Usuario</th>
                        <th>📦 Plan</th>
                        <th>🚦 Estado</th>
                        <th>🏁 Fin actual</th>
                        <th style={{ minWidth: '80px' }}>+Meses</th>
                        <th style={{ minWidth: '80px' }}>+Días</th>
                        <th>✅ Nueva fecha fin</th>
                        <th style={{ width: '50px' }}>📱</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bulkUsuarios.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4 text-muted">No hay usuarios con los filtros actuales</td>
                        </tr>
                      ) : (
                        bulkUsuarios.map((usuario, idx) => {
                          const add = getBulkAdd(usuario.correo);
                          const tieneCambio = (parseInt(add.meses) || 0) > 0 || (parseInt(add.dias) || 0) > 0;
                          const preview = tieneCambio ? calcularExtensionUsuario(usuario, add.meses, add.dias) : null;
                          return (
                            <tr key={usuario.correo || idx} className={tieneCambio ? 'table-success' : ''}>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={!!bulkSelected[usuario.correo]}
                                  onChange={() => toggleBulkSeleccion(usuario.correo)}
                                />
                              </td>
                              <td>
                                <div className="fw-bold">{usuario.nombre || '-'}</div>
                                <div className="small text-muted">{usuario.correo}</div>
                              </td>
                              <td>
                                <span className="badge bg-info">{getPlanIcon(usuario.plan)} {usuario.plan}</span>
                                {usuario.plan === 'CURSO' && usuario.curso_tipo && (
                                  <div className="mt-1 d-flex flex-wrap gap-1">
                                    {String(usuario.curso_tipo).split(',').map(c => c.trim()).filter(Boolean).map(curso => (
                                      <small key={curso} className="badge bg-secondary">
                                        🎓 {
                                          curso === 'MENORES' ? 'C. Menores' :
                                          curso === 'MAYORES' ? 'C. Mayores' :
                                          curso === 'AMBOS' ? 'Ambos' :
                                          curso
                                        }
                                      </small>
                                    ))}
                                  </div>
                                )}
                              </td>
                              <td>{getEstadoBadge(usuario.dias_restantes)}</td>
                              <td className="small">
                                {usuario.fecha_fin ? new Date(usuario.fecha_fin).toLocaleDateString('es-PE') : '-'}
                              </td>
                              <td>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control form-control-sm"
                                  style={{ width: '70px' }}
                                  value={add.meses}
                                  onChange={(e) => setBulkAddCampo(usuario.correo, 'meses', e.target.value)}
                                  placeholder="0"
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control form-control-sm"
                                  style={{ width: '70px' }}
                                  value={add.dias}
                                  onChange={(e) => setBulkAddCampo(usuario.correo, 'dias', e.target.value)}
                                  placeholder="0"
                                />
                              </td>
                              <td className="small fw-bold text-success">
                                {preview ? (
                                  <>
                                    {new Date(preview.fecha_fin).toLocaleDateString('es-PE')}
                                    {!preview.vigente && (
                                      <div><span className="badge bg-warning text-dark">renueva desde hoy</span></div>
                                    )}
                                  </>
                                ) : (
                                  <span className="text-muted">—</span>
                                )}
                              </td>
                              <td>
                                <button
                                  className="btn btn-outline-success btn-sm"
                                  title="Enviar recordatorio de renovación por WhatsApp"
                                  onClick={() => enviarWhatsAppRenovacion(usuario)}
                                >
                                  📱
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-between">
                <div className="text-muted small">
                  Seleccionados: <strong>{Object.values(bulkSelected).filter(Boolean).length}</strong>
                  {' · '}Con cambios: <strong>{contarCambiosPendientes()}</strong>
                </div>
                <div className="d-flex gap-2">
                  <button className="btn btn-secondary" onClick={() => setBulkEditOpen(false)} disabled={savingBulk}>
                    Cerrar
                  </button>
                  <button
                    className="btn btn-success fw-bold"
                    onClick={guardarCambiosMasivos}
                    disabled={savingBulk || contarCambiosPendientes() === 0}
                  >
                    {savingBulk ? (
                      <><span className="spinner-border spinner-border-sm me-2"></span>Guardando...</>
                    ) : (
                      `💾 Guardar cambios (${contarCambiosPendientes()})`
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Modal Crear Usuarios en Grupo */}
      {showModalGrupo && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050, position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', overflow: 'auto' }}>
          <div className="modal-dialog modal-xl modal-dialog-scrollable" style={{ margin: '1.5rem auto' }}>
            <div className="modal-content">
              <div className="modal-header py-3" style={{ background: 'linear-gradient(45deg, #f093fb 0%, #f5576c 100%)' }}>
                <h4 className="modal-title text-white fw-bold">👥 Crear Usuarios en Grupo</h4>
                <button type="button" className="btn-close btn-close-white" onClick={() => { setShowModalGrupo(false); setMostrarResultadosGrupo(false); setResultadosGrupo([]); }}></button>
              </div>
              <div className="modal-body p-4">
                {!mostrarResultadosGrupo ? (
                  <>
                    {/* Configuración compartida */}
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-header fw-bold" style={{ background: '#f0f0f0' }}>⚙️ Configuración compartida — aplica a todos los usuarios</div>
                      <div className="card-body">
                        <div className="row g-3">
                          <div className="col-md-4">
                            <label className="form-label fw-bold">🗂️ Plan</label>
                            <select className="form-select" value={configGrupo.plan} onChange={e => { const v = e.target.value; setConfigGrupo(prev => ({ ...prev, plan: v, curso_tipo: '', valor: v !== 'CURSO' ? prev.valor : '' })); }}>
                              <option value="">Seleccionar plan...</option>
                              <option value="MENOR">MENOR - Contratos Menores</option>
                              <option value="PAC">PAC - Plan Anual</option>
                              <option value="PREMIUM">PREMIUM - Acceso Completo</option>
                              <option value="PLUS_PLUS">PLAN PLUS+ - Acceso Completo + Generador</option>
                              <option value="CURSO">CURSO - Acceso + Cursos</option>
                              <option value="MENORES_OLD">MENORES OLD</option>
                              <option value="MAYORES_OLD">MAYORES OLD</option>
                              <option value="ADMI">ADMI - Administrador</option>
                              <option value="PRUEBA">PRUEBA - Periodo de prueba</option>
                            </select>
                          </div>
                          {configGrupo.plan === 'CURSO' && (
                            <div className="col-md-4">
                              <label className="form-label fw-bold">🎓 Tipo de Curso</label>
                              <select className="form-select" value={configGrupo.curso_tipo} onChange={e => { const tipo = e.target.value; const precio = calcularPrecioCurso(tipo); setConfigGrupo(prev => ({ ...prev, curso_tipo: tipo, valor: precio || prev.valor })); }}>
                                <option value="">Seleccionar grupo...</option>
                                {gruposCurso.map(g => (
                                  <option key={g.nombre} value={g.nombre}>{g.nombre}{g.descripcion ? ' - ' + g.descripcion : ''}{g.precio ? ' (S/. ' + g.precio + ')' : ''}</option>
                                ))}
                              </select>
                            </div>
                          )}
                          <div className="col-md-4">
                            <label className="form-label fw-bold">💵 Valor (S/.)</label>
                            <input type="number" className="form-control" value={configGrupo.valor} onChange={e => setConfigGrupo(prev => ({ ...prev, valor: e.target.value }))} readOnly={configGrupo.plan === 'CURSO'} placeholder="Ej: 299" style={{ backgroundColor: configGrupo.plan === 'CURSO' ? '#f8f9fa' : 'white' }} />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label fw-bold">📅 Fecha de inicio</label>
                            <div className="d-flex gap-2">
                              <input type="date" className="form-control" value={configGrupo.fecha_inicio} onChange={e => setConfigGrupo(prev => ({ ...prev, fecha_inicio: e.target.value }))} />
                              <button type="button" className="btn btn-outline-info btn-sm" onClick={() => setConfigGrupo(prev => ({ ...prev, fecha_inicio: new Date().toISOString().split('T')[0] }))}>Hoy</button>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <label className="form-label fw-bold">📆 Meses</label>
                            <input type="number" className="form-control" min="0" value={configGrupo.mes_suscripcion} onChange={e => setConfigGrupo(prev => ({ ...prev, mes_suscripcion: e.target.value }))} />
                          </div>
                          <div className="col-md-2">
                            <label className="form-label fw-bold">📅 Días adic.</label>
                            <input type="number" className="form-control" min="0" value={configGrupo.dias_adicionales} onChange={e => setConfigGrupo(prev => ({ ...prev, dias_adicionales: e.target.value }))} />
                          </div>
                          {configGrupo.fecha_inicio && (
                            <div className="col-md-4 d-flex align-items-end">
                              <div className="alert alert-info mb-0 w-100 py-2">
                                <small>🏁 Fecha fin: <strong>{(() => { const f = calcularFechaFin(configGrupo.fecha_inicio, configGrupo.mes_suscripcion, configGrupo.dias_adicionales); return f ? f.split('T')[0] : '—'; })()}</strong></small>
                              </div>
                            </div>
                          )}
                          <div className="col-md-4">
                            <label className="form-label fw-bold">💳 Método de pago</label>
                            <select className="form-select" value={configGrupo.medio_pago} onChange={e => setConfigGrupo(prev => ({ ...prev, medio_pago: e.target.value }))}>
                              <option value="">Seleccionar...</option>
                              <option value="TARJETA_CREDITO">💳 Tarjeta de Crédito</option>
                              <option value="TARJETA_DEBITO">💳 Tarjeta de Débito</option>
                              <option value="TRANSFERENCIA">🏦 Transferencia Bancaria</option>
                              <option value="YAPE">📱 Yape</option>
                              <option value="PLIN">📱 Plin</option>
                              <option value="EFECTIVO">💵 Efectivo</option>
                            </select>
                          </div>
                          <div className="col-md-4">
                            <label className="form-label fw-bold">📋 Comprobante</label>
                            <select className="form-select" value={configGrupo.comprobante} onChange={e => setConfigGrupo(prev => ({ ...prev, comprobante: e.target.value }))}>
                              <option value="">Seleccionar...</option>
                              <option value="FACTURA">FACTURA</option>
                              <option value="BOLETA ELECTRONICA">BOLETA ELECTRONICA</option>
                              <option value="SIN COMPROBANTE">SIN COMPROBANTE</option>
                            </select>
                          </div>
                          <div className="col-md-4 d-flex align-items-end gap-4 pb-1">
                            <div className="form-check">
                              <input type="checkbox" className="form-check-input" id="grupoEmitido" checked={configGrupo.flag_emitido} onChange={e => setConfigGrupo(prev => ({ ...prev, flag_emitido: e.target.checked }))} />
                              <label className="form-check-label fw-semibold" htmlFor="grupoEmitido">📋 Emitido</label>
                            </div>
                            <div className="form-check">
                              <input type="checkbox" className="form-check-input" id="grupoDepositado" checked={configGrupo.flag_depositado} onChange={e => setConfigGrupo(prev => ({ ...prev, flag_depositado: e.target.checked }))} />
                              <label className="form-check-label fw-semibold" htmlFor="grupoDepositado">💰 Depositado</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Plantilla del mensaje */}
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-header fw-bold" style={{ background: '#f0f0f0' }}>
                        ✏️ Plantilla del mensaje — usa <code>{'{'+'correo'+'}'}</code>, <code>{'{'+'clave'+'}'}</code>, <code>{'{'+'codigo'+'}'}</code>, <code>{'{'+'nombre'+'}'}</code>, <code>{'{'+'empresa'+'}'}</code> como variables
                      </div>
                      <div className="card-body">
                        <textarea
                          className="form-control font-monospace"
                          rows={8}
                          value={plantillaMensaje}
                          onChange={e => setPlantillaMensaje(e.target.value)}
                          style={{ fontSize: '0.85rem', resize: 'vertical' }}
                        />
                        <small className="text-muted mt-1 d-block">
                          Estas variables se reemplazarán con los datos de cada usuario al crear.
                          {' '}<strong>{'{'+'clave'+'}'}</strong> es la contraseña que se genera sola al crear la cuenta: solo se puede ver en esta pantalla.
                        </small>
                      </div>
                    </div>

                    {/* Lista de usuarios */}
                    <div className="card border-0 shadow-sm">
                      <div className="card-header d-flex justify-content-between align-items-center" style={{ background: '#f0f0f0' }}>
                        <span className="fw-bold">👤 Usuarios a crear <span className="badge bg-primary ms-1">{usuariosGrupo.length}</span></span>
                        <button type="button" className="btn btn-success btn-sm fw-bold" onClick={() => setUsuariosGrupo(prev => [...prev, { id: Date.now(), nombre: '', correo: '', celular: '', empresa: '', ruc: '', comentarios: '', comprobante: '', valor: '', dias_extra: '', flag_emitido: configGrupo.flag_emitido, flag_depositado: configGrupo.flag_depositado }])}>
                          ➕ Agregar usuario
                        </button>
                      </div>
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-bordered mb-0 align-middle">
                            <thead className="table-light">
                              <tr>
                                <th className="text-center" style={{ width: '30px' }}>#</th>
                                <th style={{ minWidth: '170px' }}>Nombre *</th>
                                <th style={{ minWidth: '210px' }}>Correo *</th>
                                <th style={{ minWidth: '130px' }}>Celular</th>
                                <th style={{ minWidth: '170px' }}>Empresa</th>
                                <th style={{ minWidth: '130px' }}>RUC</th>
                                <th style={{ minWidth: '150px' }}>Comentarios</th>
                                <th style={{ minWidth: '160px' }}>📋 Comprobante</th>
                                <th style={{ minWidth: '110px' }}>💰 Monto S/</th>
                                <th style={{ minWidth: '100px' }}>📅 Días extra</th>
                                <th className="text-center" style={{ minWidth: '70px' }}>Emitido</th>
                                <th className="text-center" style={{ minWidth: '80px' }}>Depositado</th>
                                <th style={{ width: '45px' }}></th>
                              </tr>
                            </thead>
                            <tbody>
                              {usuariosGrupo.map((u, idx) => (
                                <tr key={u.id}>
                                  <td className="text-center text-muted small">{idx + 1}</td>
                                  <td><input className="form-control form-control-sm" value={u.nombre} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, nombre: e.target.value } : x))} onPaste={e => handlePasteGrupo(e, idx, 'nombre')} placeholder="Nombre completo" /></td>
                                  <td><input className="form-control form-control-sm" type="email" value={u.correo} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, correo: e.target.value } : x))} onPaste={e => handlePasteGrupo(e, idx, 'correo')} placeholder="correo@ejemplo.com" /></td>
                                  <td><input className="form-control form-control-sm" value={u.celular} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, celular: e.target.value } : x))} onPaste={e => handlePasteGrupo(e, idx, 'celular')} placeholder="+51 999..." /></td>
                                  <td><input className="form-control form-control-sm" value={u.empresa} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, empresa: e.target.value } : x))} onPaste={e => handlePasteGrupo(e, idx, 'empresa')} placeholder="Empresa S.A.C." /></td>
                                  <td><input className="form-control form-control-sm" value={u.ruc} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, ruc: e.target.value } : x))} onPaste={e => handlePasteGrupo(e, idx, 'ruc')} placeholder="20123456789" /></td>
                                  <td><input className="form-control form-control-sm" value={u.comentarios} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, comentarios: e.target.value } : x))} onPaste={e => handlePasteGrupo(e, idx, 'comentarios')} placeholder="Opcional..." /></td>
                                  <td>
                                    <select className="form-select form-select-sm" value={u.comprobante} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, comprobante: e.target.value } : x))}>
                                      <option value="">— Config —</option>
                                      <option value="FACTURA">FACTURA</option>
                                      <option value="BOLETA ELECTRONICA">BOLETA</option>
                                      <option value="SIN COMPROBANTE">SIN COMP.</option>
                                    </select>
                                  </td>
                                  <td>
                                    <input type="number" min="0" step="0.01" className="form-control form-control-sm" value={u.valor} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, valor: e.target.value } : x))} placeholder={configGrupo.valor !== '' ? String(configGrupo.valor) : '0'} title="Déjalo vacío para usar el monto general del grupo" />
                                  </td>
                                  <td>
                                    <input type="number" min="0" step="1" className="form-control form-control-sm" value={u.dias_extra} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, dias_extra: e.target.value } : x))} placeholder="0" title="Días que se suman a la duración general del grupo, solo para este alumno" />
                                    {(parseInt(u.dias_extra) || 0) > 0 && configGrupo.fecha_inicio && (
                                      <small className="text-success d-block" style={{ fontSize: '11px' }}>
                                        hasta {(() => {
                                          const f = calcularFechaFin(
                                            configGrupo.fecha_inicio,
                                            configGrupo.mes_suscripcion,
                                            (parseInt(configGrupo.dias_adicionales) || 0) + (parseInt(u.dias_extra) || 0)
                                          );
                                          return f ? f.split('T')[0] : '—';
                                        })()}
                                      </small>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    <input type="checkbox" className="form-check-input" checked={u.flag_emitido} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, flag_emitido: e.target.checked } : x))} style={{ transform: 'scale(1.2)' }} />
                                  </td>
                                  <td className="text-center">
                                    <input type="checkbox" className="form-check-input" checked={u.flag_depositado} onChange={e => setUsuariosGrupo(prev => prev.map((x, i) => i === idx ? { ...x, flag_depositado: e.target.checked } : x))} style={{ transform: 'scale(1.2)' }} />
                                  </td>
                                  <td className="text-center">
                                    {usuariosGrupo.length > 1 && (
                                      <button type="button" className="btn btn-danger btn-sm" onClick={() => setUsuariosGrupo(prev => prev.filter((_, i) => i !== idx))}>✕</button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  /* Pantalla de resultados */
                  <div>
                    <div className="d-flex gap-2 mb-3 align-items-center flex-wrap">
                      <span className="badge bg-success fs-6 px-3 py-2">✅ {resultadosGrupo.filter(r => r.ok).length} creados correctamente</span>
                      {resultadosGrupo.filter(r => !r.ok).length > 0 && (
                        <span className="badge bg-danger fs-6 px-3 py-2">❌ {resultadosGrupo.filter(r => !r.ok).length} con error</span>
                      )}
                    </div>
                    {resultadosGrupo.map((r, idx) => (
                      <div key={idx} className={`alert ${r.ok ? (r.claveFallo ? 'alert-warning' : 'alert-success') : 'alert-danger'} py-2 mb-2`}>
                        <strong>{r.nombre}</strong> <span className="text-muted">({r.correo})</span>
                        {r.ok
                          ? ` — ${r.claveFallo ? '⚠️' : '✅'} ${r.nota || 'Creado correctamente'}`
                          : ` — ❌ ${r.error}`}
                      </div>
                    ))}
                    {resultadosGrupo.some(r => r.ok) && (
                      <div className="mt-4">
                        <p className="fw-bold mb-1">📋 Credenciales para enviar a los usuarios:</p>
                        <p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                          Las contraseñas solo se ven aquí: cópialas antes de cerrar, no se pueden volver a consultar.
                        </p>
                        <pre className="bg-light border rounded p-3" style={{ whiteSpace: 'pre-wrap', fontSize: '0.85rem', maxHeight: '300px', overflowY: 'auto' }}>
                          {resultadosGrupo.filter(r => r.ok).map(r => r.mensaje).join('\n\n' + '─'.repeat(40) + '\n\n')}
                        </pre>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                {!mostrarResultadosGrupo ? (
                  <>
                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalGrupo(false)}>Cancelar</button>
                    <button
                      type="button"
                      className="btn btn-primary fw-bold px-4"
                      onClick={handleCrearGrupo}
                      disabled={loadingGrupo || !configGrupo.plan || !configGrupo.fecha_inicio}
                    >
                      {loadingGrupo
                        ? <><span className="spinner-border spinner-border-sm me-2"></span>Creando usuarios...</>
                        : `💾 Crear ${usuariosGrupo.filter(u => u.nombre.trim() && u.correo.trim()).length || usuariosGrupo.length} Usuario${usuariosGrupo.length !== 1 ? 's' : ''}`
                      }
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setShowModalGrupo(false);
                        setMostrarResultadosGrupo(false);
                        setResultadosGrupo([]);
                        setUsuariosGrupo([{ id: 1, nombre: '', correo: '', celular: '', empresa: '', ruc: '', comentarios: '', comprobante: '', valor: '', dias_extra: '', flag_emitido: false, flag_depositado: false }]);
                        setConfigGrupo({ plan: '', curso_tipo: '', fecha_inicio: '', mes_suscripcion: 1, dias_adicionales: 0, valor: '', medio_pago: '', comprobante: '', flag_emitido: false, flag_depositado: false });
                      }}
                    >
                      Cerrar
                    </button>
                    {resultadosGrupo.some(r => r.ok) && (
                      <button
                        type="button"
                        className="btn btn-success fw-bold px-4"
                        onClick={() => {
                          const texto = resultadosGrupo.filter(r => r.ok).map(r => r.mensaje).join('\n\n' + '─'.repeat(40) + '\n\n');
                          navigator.clipboard.writeText(texto)
                            .then(() => alert('📋 ¡Credenciales copiadas al portapapeles! Solo pega con Ctrl+V.'))
                            .catch(() => alert('No se pudo copiar automáticamente. Selecciona el texto manualmente.'));
                        }}
                      >
                        📋 Copiar Credenciales
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Admin;